import { type Theme } from '@eduzz/shared';

/* eslint-disable max-lines */
export const fallbackTheme: NonNullable<Theme['antd']> = {
  light: {
    token: {
      fontFamily: 'DM Sans',
      blue1: '#e6f4ff',
      blue2: '#bae0ff',
      blue3: '#91caff',
      blue4: '#69b1ff',
      blue5: '#4096ff',
      blue6: '#1677ff',
      blue7: '#0958d9',
      blue8: '#003eb3',
      blue9: '#002c8c',
      blue10: '#001d66',
      cyan1: '#e6fffb',
      cyan2: '#b5f5ec',
      cyan3: '#87e8de',
      cyan4: '#5cdbd3',
      cyan5: '#36cfc9',
      cyan6: '#13c2c2',
      cyan7: '#08979c',
      cyan8: '#006d75',
      cyan9: '#00474f',
      cyan10: '#002329',
      geekblue1: '#f0f5ff',
      geekblue2: '#d6e4ff',
      geekblue3: '#adc6ff',
      geekblue4: '#85a5ff',
      geekblue5: '#597ef7',
      geekblue6: '#2f54eb',
      geekblue7: '#1d39c4',
      geekblue8: '#10239e',
      geekblue9: '#061178',
      geekblue10: '#030852',
      gold1: '#fffbe6',
      gold2: '#fff1b8',
      gold3: '#ffe58f',
      gold4: '#ffd666',
      gold5: '#ffc53d',
      gold6: '#faad14',
      gold7: '#d48806',
      gold8: '#ad6800',
      gold9: '#874d00',
      gold10: '#613400',
      green1: '#f6ffed',
      green2: '#d9f7be',
      green3: '#b7eb8f',
      green4: '#95de64',
      green5: '#73d13d',
      green6: '#52c41a',
      green7: '#389e0d',
      green8: '#237804',
      green9: '#135200',
      green10: '#092b00',
      lime1: '#fcffe6',
      lime2: '#f4ffb8',
      lime3: '#eaff8f',
      lime4: '#d3f261',
      lime5: '#bae637',
      lime6: '#a0d911',
      lime7: '#7cb305',
      lime8: '#5b8c00',
      lime9: '#3f6600',
      lime10: '#254000',
      magenta1: '#fff0f6',
      magenta2: '#ffd6e7',
      magenta3: '#ffadd2',
      magenta4: '#ff85c0',
      magenta5: '#f759ab',
      magenta6: '#eb2f96',
      magenta7: '#c41d7f',
      magenta8: '#9e1068',
      magenta9: '#780650',
      magenta10: '#520339',
      orange1: '#fff7e6',
      orange2: '#ffe7ba',
      orange3: '#ffd591',
      orange4: '#ffc069',
      colorText: 'rgba(0, 0, 0, 0.88)',
      colorTextSecondary: 'rgba(0, 0, 0, 0.65)',
      orange5: '#ffa940',
      colorTextTertiary: 'rgba(0, 0, 0, 0.45)',
      colorTextQuaternary: 'rgba(0, 0, 0, 0.25)',
      orange6: '#fa8c16',
      orange7: '#d46b08',
      colorTextLightSolid: '#ffffff',
      colorTextHeading: 'rgba(0, 0, 0, 0.88)',
      colorTextLabel: 'rgba(0, 0, 0, 0.65)',
      orange8: '#ad4e00',
      colorTextDescription: 'rgba(0, 0, 0, 0.45)',
      orange9: '#873800',
      colorTextDisabled: 'rgba(0, 0, 0, 0.25)',
      orange10: '#612500',
      purple1: '#f9f0ff',
      purple2: '#efdbff',
      purple3: '#d3adf7',
      colorTextPlaceholder: 'rgba(0, 0, 0, 0.25)',
      colorIcon: 'rgba(0, 0, 0, 0.45)',
      purple4: '#b37feb',
      colorIconHover: 'rgba(0, 0, 0, 0.88)',
      colorBgContainer: '#ffffff',
      purple5: '#9254de',
      colorBgElevated: '#ffffff',
      purple6: '#722ed1',
      colorBgLayout: '#f5f5f5',
      purple7: '#531dab',
      colorBgMask: 'rgba(0, 0, 0, 0.45)',
      purple8: '#391085',
      colorBgSpotlight: 'rgba(0, 0, 0, 0.85)',
      purple9: '#22075e',
      colorBorder: '#d9d9d9',
      purple10: '#120338',
      colorBorderSecondary: '#f0f0f0',
      red1: '#fff1f0',
      colorFill: 'rgba(0, 0, 0, 0.15)',
      red2: '#ffccc7',
      colorFillSecondary: 'rgba(0, 0, 0, 0.06)',
      colorFillTertiary: 'rgba(0, 0, 0, 0.04)',
      colorFillQuaternary: 'rgba(0, 0, 0, 0.02)',
      red3: '#ffa39e',
      red4: '#ff7875',
      colorWhite: '#ffffff',
      red5: '#ff4d4f',
      colorBgBase: '#ffffff',
      red6: '#f5222d',
      colorTextBase: '#000000',
      red7: '#cf1322',
      red8: '#a8071a',
      colorBgContainerDisabled: 'rgba(0, 0, 0, 0.04)',
      red9: '#820014',
      colorBgTextActive: 'rgba(0, 0, 0, 0.15)',
      red10: '#5c0011',
      colorBgTextHover: 'rgba(0, 0, 0, 0.06)',
      volcano1: '#fff2e8',
      colorBorderBg: '#ffffff',
      volcano2: '#ffd8bf',
      colorFillContent: 'rgba(0, 0, 0, 0.06)',
      volcano3: '#ffbb96',
      colorFillContentHover: 'rgba(0, 0, 0, 0.15)',
      volcano4: '#ff9c6e',
      colorFillAlter: 'rgba(0, 0, 0, 0.02)',
      volcano5: '#ff7a45',
      volcano6: '#fa541c',
      volcano7: '#d4380d',
      colorSplit: 'rgba(0, 0, 0, 0.06)',
      yellow1: '#feffe6',
      volcano8: '#ad2102',
      yellow2: '#ffffb8',
      yellow3: '#fffb8f',
      volcano9: '#871400',
      yellow4: '#fff566',
      volcano10: '#610b00',
      yellow5: '#ffec3d',
      yellow6: '#fadb14',
      yellow7: '#d4b106',
      yellow8: '#ad8b00',
      yellow9: '#876800',
      yellow10: '#614700',
      colorPrimary: '#0d2772',
      colorSuccess: '#52c41a',
      colorWarning: '#faad14',
      colorInfo: '#153fb8',
      colorError: '#ff4d4f',
      colorLink: '#153fb8',
      colorErrorBg: '#fff2f0',
      colorErrorBgHover: '#fff1f0',
      colorErrorBorder: '#ffccc7',
      colorErrorBorderHover: '#ffa39e',
      colorErrorHover: '#ff7875',
      colorErrorActive: '#d9363e',
      colorErrorTextHover: '#ff7875',
      colorErrorText: '#ff4d4f',
      colorErrorTextActive: '#d9363e',
      colorLinkHover: '#355ec4',
      colorInfoBg: '#e1eaf7',
      colorInfoBgHover: '#b0c6eb',
      colorInfoBorder: '#83a3de',
      colorInfoBorderHover: '#5a80d1',
      colorInfoHover: '#355ec4',
      colorInfoActive: '#092691',
      colorInfoTextHover: '#355ec4',
      colorInfoText: '#153eb8',
      colorInfoTextActive: '#092691',
      colorLinkActive: '#092691',
      colorPrimaryBg: '#e1eaf7',
      colorPrimaryBgHover: '#b0c6eb',
      colorPrimaryBorder: '#83a3de',
      colorPrimaryBorderHover: '#5a80d1',
      colorPrimaryHover: '#355ec4',
      colorPrimaryActive: '#092691',
      colorPrimaryTextHover: '#355ec4',
      colorPrimaryText: '#153eb8',
      colorPrimaryTextActive: '#092691',
      colorSuccessBg: '#f6ffed',
      colorSuccessBgHover: '#d9f7be',
      colorSuccessBorder: '#b7eb8f',
      colorSuccessBorderHover: '#95de64',
      colorSuccessHover: '#95de64',
      colorSuccessActive: '#389e0d',
      colorSuccessTextHover: '#73d13d',
      colorSuccessText: '#52c41a',
      colorSuccessTextActive: '#389e0d',
      colorWarningBg: '#fffbe6',
      colorWarningBgHover: '#fff1b8',
      colorWarningBorder: '#ffe58f',
      colorWarningBorderHover: '#ffd666',
      colorWarningHover: '#ffd666',
      colorWarningActive: '#d48806',
      colorWarningTextHover: '#ffc53d',
      colorWarningText: '#faad14',
      colorWarningTextActive: '#d48806',
      colorErrorOutline: 'rgba(255, 38, 6, 0.06)',
      colorWarningOutline: 'rgba(255, 215, 5, 0.1)',
      controlItemBgActive: '#e1eaf7',
      controlItemBgActiveDisabled: 'rgba(0, 0, 0, 0.15)',
      controlItemBgActiveHover: '#b0c6eb',
      controlItemBgHover: 'rgba(0, 0, 0, 0.04)',
      controlOutline: 'rgba(21, 63, 184, 0.1)',
      controlTmpOutline: 'rgba(0, 0, 0, 0.02)',
      borderRadius: 4,
      borderRadiusLG: 4,
      borderRadiusSM: 4,
      borderRadiusXS: 2,
      sizeStep: 4,
      sizeUnit: 4,
      controlInteractiveSize: 16,
      size: 16,
      sizeLG: 24,
      sizeMD: 20,
      sizeMS: 16,
      sizeSM: 12,
      sizeXL: 32,
      sizeXS: 8,
      sizeXXL: 48,
      controlHeight: 32,
      sizeXXS: 4,
      controlHeightLG: 40,
      controlHeightSM: 24,
      controlHeightXS: 16,
      lineWidth: 1,
      lineWidthBold: 2,
      lineWidthFocus: 4,
      controlOutlineWidth: 2,
      screenLG: 992,
      screenLGMax: 1199,
      screenLGMin: 992,
      screenMD: 768,
      screenMDMax: 991,
      screenMDMin: 768,
      screenSM: 576,
      screenSMMax: 767,
      screenSMMin: 576,
      screenXL: 1200,
      screenXLMax: 1599,
      screenXLMin: 1200,
      screenXS: 480,
      screenXSMax: 575,
      screenXSMin: 480,
      screenXXL: 1600,
      screenXXLMin: 1600,
      sizePopupArrow: 16,
      margin: 16,
      marginLG: 24,
      marginMD: 20,
      marginSM: 12,
      marginXL: 32,
      marginXS: 8,
      marginXXL: 48,
      marginXXS: 4,
      padding: 16,
      paddingLG: 24,
      paddingMD: 20,
      paddingSM: 12,
      paddingXL: 32,
      paddingXS: 8,
      paddingXXS: 4,
      paddingContentHorizontal: 16,
      paddingContentHorizontalLG: 24,
      paddingContentHorizontalSM: 16,
      paddingContentVertical: 12,
      paddingContentVerticalLG: 16,
      paddingContentVerticalSM: 8,
      controlPaddingHorizontal: 12,
      controlPaddingHorizontalSM: 8,
      fontFamilyCode: 'Courier Prime',
      fontSize: 14,
      fontSizeLG: 16,
      fontSizeSM: 12,
      fontSizeXL: 20,
      fontSizeHeading1: 38,
      fontSizeHeading2: 30,
      fontSizeHeading3: 24,
      fontSizeHeading4: 20,
      fontSizeHeading5: 16,
      lineHeight: 1.5714285714285714,
      lineHeightHeading1: 1.2105263157894737,
      lineHeightHeading2: 1.2666666666666666,
      lineHeightHeading3: 1.3333333333333333,
      lineHeightHeading4: 1.4,
      lineHeightHeading5: 1.5,
      lineHeightLG: 1.5,
      lineHeightSM: 1.6666666666666667,
      fontSizeIcon: 12,
      fontWeightStrong: 600,
      colorBgSolid: '#000000',
      colorBgSolidActive: 'rgba(0, 0, 0, 0.95)',
      colorBgSolidHover: 'rgba(0, 0, 0, 0.75)',
      pink1: '#fff0f6',
      pink2: '#ffd6e7',
      pink3: '#ffadd2',
      pink4: '#ff85c0',
      pink5: '#f759ab',
      pink6: '#eb2f96',
      pink7: '#c41d7f',
      pink8: '#9e1068',
      pink9: '#780650',
      pink10: '#520339'
    },
    components: {
      Input: {
        paddingInlineSM: 7,
        paddingInlineLG: 11,
        paddingInline: 11,
        paddingBlockSM: 0,
        paddingBlockLG: 7,
        paddingBlock: 4,
        hoverBorderColor: '#355ec4',
        addonBg: 'rgba(0, 0, 0, 0.02)',
        activeBorderColor: '#0d2772',
        activeBg: '#ffffff',
        hoverBg: '#ffffff',
        inputFontSize: 14,
        inputFontSizeLG: 16,
        inputFontSizeSM: 12
      },
      Transfer: {
        listWidthLG: 250,
        listWidth: 180,
        listHeight: 200,
        itemPaddingBlock: 5,
        itemHeight: 32,
        headerHeight: 40
      },
      Segmented: {
        itemSelectedColor: 'rgba(0, 0, 0, 0.88)',
        itemSelectedBg: '#ffffff',
        itemHoverColor: 'rgba(0, 0, 0, 0.88)',
        itemHoverBg: 'rgba(0, 0, 0, 0.06)',
        itemColor: 'rgba(0, 0, 0, 0.65)',
        itemActiveBg: 'rgba(0, 0, 0, 0.15)',
        trackPadding: 2,
        trackBg: '#f5f5f5'
      },
      Switch: {
        trackPadding: 2,
        trackMinWidthSM: 28,
        trackMinWidth: 44,
        trackHeightSM: 16,
        trackHeight: 22,
        handleSizeSM: 12,
        handleSize: 18,
        handleBg: '#ffffff'
      },
      Timeline: {
        itemPaddingBottom: 20,
        tailColor: 'rgba(0, 0, 0, 0.06)',
        dotBg: '#ffffff'
      },
      Tabs: {
        horizontalItemGutter: 32,
        cardGutter: 2,
        itemSelectedColor: '#0d2772',
        itemHoverColor: '#355ec4',
        itemColor: 'rgba(0, 0, 0, 0.88)',
        itemActiveColor: '#092691',
        inkBarColor: '#0d2772',
        cardHeight: 40,
        cardBg: 'rgba(0, 0, 0, 0.02)',
        titleFontSize: 14,
        titleFontSizeLG: 16,
        titleFontSizeSM: 14
      },
      Table: {
        stickyScrollBarBorderRadius: 100,
        headerSplitColor: '#f0f0f0',
        headerBg: 'rgba(0, 0, 0, 0.02)',
        footerBg: 'rgba(0, 0, 0, 0.02)',
        rowSelectedHoverBg: '#b0c6eb',
        headerFilterHoverBg: 'rgba(0, 0, 0, 0.06)',
        headerColor: 'rgba(0, 0, 0, 0.88)',
        headerBorderRadius: 8,
        footerColor: 'rgba(0, 0, 0, 0.88)',
        filterDropdownMenuBg: '#ffffff',
        filterDropdownBg: '#ffffff',
        cellPaddingInlineSM: 8,
        cellPaddingInlineMD: 8,
        cellPaddingInline: 16,
        cellPaddingBlockSM: 8,
        cellPaddingBlockMD: 12,
        cellPaddingBlock: 16,
        borderColor: '#f0f0f0',
        rowHoverBg: '#fafafa',
        headerSortActiveBg: 'rgba(0, 0, 0, 0.06)',
        bodySortBg: '#fafafa',
        headerSortHoverBg: 'rgba(0, 0, 0, 0.06)',
        cellFontSize: 14,
        cellFontSizeMD: 14,
        cellFontSizeSM: 14
      },
      Steps: {
        dotSize: 8,
        dotCurrentSize: 10,
        descriptionMaxWidth: 140,
        titleLineHeight: 32,
        iconSizeSM: 24,
        iconSize: 32,
        customIconFontSize: 24,
        iconFontSize: 14
      },
      Spin: {
        dotSizeSM: 14,
        dotSize: 20,
        contentHeight: 400,
        dotSizeLG: 32
      },
      Slider: {
        railSize: 4,
        handleSizeHover: 12,
        dotSize: 8,
        controlSize: 10,
        handleSize: 10,
        trackHoverBg: '#5a80d1',
        trackBgDisabled: 'rgba(0, 0, 0, 0.04)',
        trackBg: '#83a3de',
        railHoverBg: 'rgba(0, 0, 0, 0.06)',
        railBg: 'rgba(0, 0, 0, 0.04)',
        handleColor: '#83a3de',
        handleActiveColor: '#0d2772',
        dotBorderColor: '#f0f0f0',
        dotActiveBorderColor: '#83a3de',
        handleColorDisabled: '#bfbfbf'
      },
      Radio: {
        radioSize: 16,
        dotSize: 8,
        buttonPaddingInline: 15,
        wrapperMarginInlineEnd: 8,
        dotColorDisabled: 'rgba(0, 0, 0, 0.25)',
        buttonSolidCheckedHoverBg: '#355ec4',
        buttonSolidCheckedColor: '#ffffff',
        buttonSolidCheckedBg: '#0d2772',
        buttonSolidCheckedActiveBg: '#092691',
        buttonColor: 'rgba(0, 0, 0, 0.88)',
        buttonCheckedColorDisabled: 'rgba(0, 0, 0, 0.25)',
        buttonCheckedBgDisabled: 'rgba(0, 0, 0, 0.15)',
        buttonCheckedBg: '#ffffff',
        buttonBg: '#ffffff'
      },
      Popover: {
        titleMinWidth: 177
      },
      Notification: {
        width: 384
      },
      Menu: {
        subMenuItemBg: 'rgba(0, 0, 0, 0.02)',
        darkSubMenuItemBg: '#000c17',
        darkItemDisabledColor: 'rgba(255, 255, 255, 0.25)',
        darkItemColor: 'rgba(255, 255, 255, 0.65)',
        darkGroupTitleColor: 'rgba(255, 255, 255, 0.65)',
        darkItemBg: '#001529',
        subMenuItemBorderRadius: 4,
        popupBg: '#ffffff',
        itemSelectedColor: '#0d2772',
        itemSelectedBg: '#e1eaf7',
        itemHoverColor: 'rgba(0, 0, 0, 0.88)',
        itemHoverBg: 'rgba(0, 0, 0, 0.06)',
        itemHeight: 40,
        itemDisabledColor: 'rgba(0, 0, 0, 0.25)',
        itemColor: 'rgba(0, 0, 0, 0.88)',
        itemBorderRadius: 8,
        itemBg: '#ffffff',
        iconSize: 14,
        horizontalItemSelectedColor: '#0d2772',
        horizontalItemSelectedBg: 'rgba(0, 0, 0, 0)',
        horizontalItemHoverColor: '#0d2772',
        horizontalItemHoverBg: 'rgba(0, 0, 0, 0)',
        groupTitleColor: 'rgba(0, 0, 0, 0.45)',
        darkItemSelectedColor: '#ffffff',
        darkItemSelectedBg: '#0d2772',
        darkItemHoverColor: '#ffffff',
        darkItemHoverBg: 'rgba(0, 0, 0, 0)',
        collapsedIconSize: 16,
        darkPopupBg: '#001529',
        activeBarBorderWidth: 1,
        collapsedWidth: 80,
        dropdownWidth: 160,
        itemMarginBlock: 4,
        itemMarginInline: 4,
        iconMarginInlineEnd: 10,
        groupTitleFontSize: 14,
        groupTitleLineHeight: 1.5714285714285714,
        subMenuItemSelectedColor: '#0d2772'
      },
      InputNumber: {
        paddingInlineSM: 7,
        paddingInlineLG: 11,
        paddingInline: 11,
        paddingBlockSM: 0,
        paddingBlockLG: 7,
        paddingBlock: 4,
        handleWidth: 22,
        controlWidth: 90,
        hoverBorderColor: '#355ec4',
        handleHoverColor: '#0d2772',
        handleBorderColor: '#d9d9d9',
        handleBg: '#ffffff',
        handleActiveBg: 'rgba(0, 0, 0, 0.02)',
        addonBg: 'rgba(0, 0, 0, 0.02)',
        activeBorderColor: '#0d2772',
        activeBg: '#ffffff',
        hoverBg: '#ffffff',
        inputFontSize: 14,
        inputFontSizeLG: 16,
        inputFontSizeSM: 12,
        filledHandleBg: '#f0f0f0'
      },
      Image: {
        previewOperationSize: 18,
        previewOperationHoverColor: 'rgba(255, 255, 255, 0.85)',
        previewOperationColorDisabled: 'rgba(255, 255, 255, 0.25)',
        previewOperationColor: 'rgba(255, 255, 255, 0.65)'
      },
      Card: {
        headerHeightSM: 38,
        headerHeight: 56,
        headerBg: 'rgba(0, 0, 0, 0)',
        headerFontSize: 16,
        headerFontSizeSM: 14,
        bodyPaddingSM: 12,
        headerPaddingSM: 12,
        bodyPadding: 24,
        headerPadding: 24
      },
      Carousel: {
        dotWidth: 16,
        dotHeight: 3,
        dotActiveWidth: 24
      },
      Cascader: {
        dropdownHeight: 180,
        controlWidth: 184,
        controlItemWidth: 111,
        optionSelectedBg: '#e1eaf7',
        menuPadding: 4,
        optionSelectedFontWeight: 600,
        optionSelectedColor: 'rgba(0, 0, 0, 0.88)'
      },
      Calendar: {
        yearControlWidth: 80,
        monthControlWidth: 70,
        itemActiveBg: '#e1eaf7',
        fullPanelBg: '#ffffff',
        fullBg: '#ffffff'
      },
      Button: {
        boxShadow: 'none',
        defaultShadow: 'none',
        primaryShadow: 'none',
        paddingInlineSM: 7,
        paddingInlineLG: 16,
        paddingInline: 16,
        onlyIconSizeSM: 14,
        onlyIconSizeLG: 18,
        contentLineHeight: 1.5714285714285714,
        contentFontSizeLG: 16,
        contentFontSize: 14,
        textHoverBg: 'rgba(0, 0, 0, 0.06)',
        primaryColor: '#ffffff',
        onlyIconSize: 16,
        linkHoverBg: 'rgba(0, 0, 0, 0)',
        groupBorderColor: '#355ec4',
        ghostBg: 'rgba(0, 0, 0, 0)',
        defaultGhostColor: '#ffffff',
        defaultGhostBorderColor: '#ffffff',
        defaultColor: 'rgba(0, 0, 0, 0.88)',
        defaultBorderColor: '#d9d9d9',
        defaultBg: '#ffffff',
        dangerColor: '#ffffff',
        borderColorDisabled: '#d9d9d9',
        defaultHoverBg: '#ffffff',
        defaultHoverColor: '#355ec4',
        defaultHoverBorderColor: '#355ec4',
        defaultActiveBg: '#ffffff',
        defaultActiveColor: '#092691',
        defaultActiveBorderColor: '#092691',
        fontWeight: 500,
        contentFontSizeSM: 14,
        contentLineHeightLG: 1.5,
        contentLineHeightSM: 1.5714285714285714,
        textTextActiveColor: 'rgba(0, 0, 0, 0.88)',
        textTextHoverColor: 'rgba(0, 0, 0, 0.88)',
        textTextColor: 'rgba(0, 0, 0, 0.88)',
        solidTextColor: '#ffffff'
      },
      Badge: {
        statusSize: 6,
        indicatorHeight: 20,
        dotSize: 6,
        indicatorHeightSM: 14,
        textFontSize: 12,
        textFontSizeSM: 12
      },
      Form: {
        labelRequiredMarkColor: '#ff4d4f',
        labelColor: 'rgba(0, 0, 0, 0.88)',
        itemMarginBottom: 24,
        labelColonMarginInlineEnd: 8,
        labelColonMarginInlineStart: 2,
        labelHeight: 32,
        labelFontSize: 14
      },
      Avatar: {
        containerSizeSM: 24,
        containerSizeLG: 40,
        containerSize: 32,
        textFontSize: 18,
        textFontSizeLG: 24,
        textFontSizeSM: 14
      },
      Tour: {
        closeBtnSize: 22,
        primaryNextBtnHoverBg: '#f0f0f0',
        primaryPrevBtnBg: 'rgba(255, 255, 255, 0.15)'
      },
      TreeSelect: {
        titleHeight: 24,
        nodeSelectedBg: '#e1eaf7',
        nodeHoverBg: 'rgba(0, 0, 0, 0.04)'
      },
      Tree: {
        titleHeight: 24,
        nodeSelectedBg: '#e1eaf7',
        nodeHoverBg: 'rgba(0, 0, 0, 0.04)',
        directoryNodeSelectedColor: '#ffffff',
        directoryNodeSelectedBg: '#0d2772',
        nodeHoverColor: 'rgba(0, 0, 0, 0.88)',
        nodeSelectedColor: 'rgba(0, 0, 0, 0.88)',
        indentSize: 24
      },
      Tag: {
        defaultColor: 'rgba(0, 0, 0, 0.88)',
        defaultBg: 'rgba(0, 0, 0, 0.02)'
      },
      Statistic: {
        contentFontSize: 24,
        titleFontSize: 14
      },
      Select: {
        singleItemHeightLG: 40,
        selectorBg: '#ffffff',
        optionSelectedColor: 'rgba(0, 0, 0, 0.88)',
        optionSelectedBg: '#e1eaf7',
        optionHeight: 32,
        optionActiveBg: 'rgba(0, 0, 0, 0.04)',
        multipleSelectorBgDisabled: 'rgba(0, 0, 0, 0.04)',
        multipleItemHeightLG: 32,
        multipleItemHeight: 24,
        multipleItemColorDisabled: 'rgba(0, 0, 0, 0.25)',
        multipleItemBorderColorDisabled: 'rgba(0, 0, 0, 0)',
        multipleItemBorderColor: 'rgba(0, 0, 0, 0)',
        multipleItemBg: 'rgba(0, 0, 0, 0.06)',
        clearBg: '#ffffff',
        optionSelectedFontWeight: 600,
        showArrowPaddingInlineEnd: 18,
        activeBorderColor: '#0d2772',
        hoverBorderColor: '#355ec4'
      },
      Result: {
        iconFontSize: 72,
        subtitleFontSize: 14,
        titleFontSize: 24
      },
      Progress: {
        remainingColor: 'rgba(0, 0, 0, 0.06)',
        defaultColor: '#153fb8',
        circleTextColor: 'rgba(0, 0, 0, 0.88)'
      },
      Pagination: {
        itemSizeSM: 24,
        itemSize: 32,
        itemLinkBg: '#ffffff',
        itemInputBg: '#ffffff',
        itemBg: '#ffffff',
        itemActiveColorDisabled: 'rgba(0, 0, 0, 0.25)',
        itemActiveBgDisabled: 'rgba(0, 0, 0, 0.15)',
        itemActiveBg: '#ffffff'
      },
      Modal: {
        titleColor: 'rgba(0, 0, 0, 0.88)',
        headerBg: '#ffffff',
        footerBg: 'rgba(0, 0, 0, 0)',
        contentBg: '#ffffff',
        titleFontSize: 16,
        titleLineHeight: 1.375
      },
      Message: {
        contentBg: '#ffffff'
      },
      List: {
        headerBg: 'rgba(0, 0, 0, 0)',
        footerBg: 'rgba(0, 0, 0, 0)',
        avatarMarginRight: 16,
        descriptionFontSize: 14
      },
      Dropdown: {
        paddingBlock: 5
      },
      Descriptions: {
        titleColor: 'rgba(0, 0, 0, 0.88)',
        labelBg: 'rgba(0, 0, 0, 0.02)',
        contentColor: 'rgba(0, 0, 0, 0.88)',
        labelColor: 'rgba(0, 0, 0, 0.45)'
      },
      DatePicker: {
        borderRadius: 8,
        colorTextPlaceholder: 'rgba(0, 0, 0, 0.88)',
        hoverBorderColor: '#355ec4',
        cellHoverBg: 'rgba(0, 0, 0, 0.04)',
        cellHeight: 24,
        activeBorderColor: '#0d2772',
        paddingInline: 11,
        paddingInlineSM: 7,
        activeBg: '#ffffff',
        hoverBg: '#ffffff',
        cellBgDisabled: 'rgba(0, 0, 0, 0.04)',
        cellActiveWithRangeBg: '#e1eaf7',
        cellHoverWithRangeBg: '#c8dfff',
        cellRangeBorderColor: '#7cb3ff',
        multipleItemBg: 'rgba(0, 0, 0, 0.06)',
        multipleItemBorderColor: 'rgba(0, 0, 0, 0)',
        multipleItemBorderColorDisabled: 'rgba(0, 0, 0, 0)',
        multipleItemColorDisabled: 'rgba(0, 0, 0, 0.25)',
        multipleSelectorBgDisabled: 'rgba(0, 0, 0, 0.04)',
        cellWidth: 36,
        multipleItemHeight: 24,
        multipleItemHeightLG: 32,
        multipleItemHeightSM: 16,
        paddingBlock: 4,
        paddingBlockLG: 7,
        paddingBlockSM: 0,
        presetsMaxWidth: 200,
        presetsWidth: 120,
        textHeight: 40,
        timeCellHeight: 28,
        timeColumnHeight: 224,
        timeColumnWidth: 56,
        withoutTimeCellHeight: 66,
        inputFontSize: 14,
        inputFontSizeLG: 16,
        inputFontSizeSM: 12
      },
      Collapse: {
        headerBg: 'rgba(0, 0, 0, 0.02)',
        contentBg: '#ffffff'
      },
      Breadcrumb: {
        separatorColor: 'rgba(0, 0, 0, 0.45)',
        linkHoverColor: 'rgba(0, 0, 0, 0.88)',
        linkColor: 'rgba(0, 0, 0, 0.45)',
        lastItemColor: 'rgba(0, 0, 0, 0.88)',
        itemColor: 'rgba(0, 0, 0, 0.45)',
        separatorMargin: 8,
        iconFontSize: 14
      },
      Anchor: {
        linkPaddingInlineStart: 16,
        linkPaddingBlock: 4
      },
      Alert: {
        withDescriptionIconSize: 24
      },
      Layout: {
        bodyBg: '#f5f5f5',
        footerBg: '#f5f5f5',
        headerBg: '#001529',
        headerColor: 'rgba(0, 0, 0, 0.88)',
        lightSiderBg: '#ffffff',
        lightTriggerBg: '#ffffff',
        lightTriggerColor: 'rgba(0, 0, 0, 0.88)',
        siderBg: '#001529',
        triggerBg: '#002140',
        triggerColor: '#ffffff',
        headerHeight: 64,
        triggerHeight: 48,
        zeroTriggerHeight: 40,
        zeroTriggerWidth: 40
      }
    }
  },
  dark: {
    token: {
      'blue.1': '#111a2c',
      'blue.2': '#112545',
      'blue.3': '#15325b',
      'blue.4': '#15417e',
      'blue.5': '#1554ad',
      'blue.6': '#1668dc',
      'blue.7': '#3c89e8',
      'blue.8': '#65a9f3',
      'blue.9': '#8dc5f8',
      'blue.10': '#b7dcfa',
      'cyan.1': '#112123',
      'cyan.2': '#113536',
      'cyan.3': '#144848',
      'cyan.4': '#146262',
      'cyan.5': '#138585',
      'cyan.6': '#13a8a8',
      'cyan.7': '#33bcb7',
      'cyan.8': '#58d1c9',
      'cyan.9': '#84e2d8',
      'cyan.10': '#b2f1e8',
      'geekblue.1': '#131629',
      'geekblue.2': '#161d40',
      'geekblue.3': '#1c2755',
      'geekblue.4': '#203175',
      'geekblue.5': '#263ea0',
      'geekblue.6': '#2b4acb',
      'geekblue.7': '#5273e0',
      'geekblue.8': '#7f9ef3',
      'geekblue.9': '#a8c1f8',
      'geekblue.10': '#d2e0fa',
      'gold.1': '#2b2111',
      'gold.2': '#443111',
      'gold.3': '#594214',
      'gold.4': '#7c5914',
      'gold.5': '#aa7714',
      'gold.6': '#d89614',
      'gold.7': '#e8b339',
      'gold.8': '#f3cc62',
      'gold.9': '#f8df8b',
      'gold.10': '#faedb5',
      'green.1': '#162312',
      'green.2': '#1d3712',
      'green.3': '#274916',
      'green.4': '#306317',
      'green.5': '#3c8618',
      'green.6': '#49aa19',
      'green.7': '#6abe39',
      'green.8': '#8fd460',
      'green.9': '#b2e58b',
      'green.10': '#d5f2bb',
      'lime.1': '#1f2611',
      'lime.2': '#2e3c10',
      'lime.3': '#3e4f13',
      'lime.4': '#536d13',
      'lime.5': '#6f9412',
      'lime.6': '#8bbb11',
      'lime.7': '#a9d134',
      'lime.8': '#c9e75d',
      'lime.9': '#e4f88b',
      'lime.10': '#f0fab5',
      'magenta.1': '#291321',
      'magenta.2': '#40162f',
      'magenta.3': '#551c3b',
      'magenta.4': '#75204f',
      'magenta.5': '#a02669',
      'magenta.6': '#cb2b83',
      'magenta.7': '#e0529c',
      'magenta.8': '#f37fb7',
      'magenta.9': '#f8a8cc',
      'magenta.10': '#fad2e3',
      'orange.1': '#2b1d11',
      'orange.2': '#442a11',
      'orange.3': '#593815',
      'orange.4': '#7c4a15',
      'colorText': 'rgba(255, 255, 255, 0.85)',
      'colorTextSecondary': 'rgba(255, 255, 255, 0.65)',
      'orange.5': '#aa6215',
      'colorTextTertiary': 'rgba(255, 255, 255, 0.45)',
      'colorTextQuaternary': 'rgba(255, 255, 255, 0.25)',
      'orange.6': '#d87a16',
      'orange.7': '#e89a3c',
      'colorTextLightSolid': '#ffffff',
      'colorTextHeading': 'rgba(255, 255, 255, 0.85)',
      'colorTextLabel': 'rgba(255, 255, 255, 0.65)',
      'orange.8': '#f3b765',
      'colorTextDescription': 'rgba(255, 255, 255, 0.45)',
      'orange.9': '#f8cf8d',
      'colorTextDisabled': 'rgba(255, 255, 255, 0.25)',
      'orange.10': '#fae3b7',
      'purple.1': '#1a1325',
      'purple.2': '#24163a',
      'purple.3': '#301c4d',
      'colorTextPlaceholder': 'rgba(255, 255, 255, 0.25)',
      'colorIcon': 'rgba(255, 255, 255, 0.45)',
      'purple.4': '#3e2069',
      'colorIconHover': 'rgba(255, 255, 255, 0.85)',
      'colorBgContainer': '#141414',
      'purple.5': '#51258f',
      'colorBgElevated': '#1f1f1f',
      'purple.6': '#642ab5',
      'colorBgLayout': '#000000',
      'purple.7': '#854eca',
      'colorBgMask': 'rgba(0, 0, 0, 0.45)',
      'purple.8': '#ab7ae0',
      'colorBgSpotlight': '#424242',
      'purple.9': '#cda8f0',
      'colorBorder': '#424242',
      'purple.10': '#ebd7fa',
      'colorBorderSecondary': '#303030',
      'red.1': '#2a1215',
      'colorFill': 'rgba(255, 255, 255, 0.18)',
      'red.2': '#431418',
      'colorFillSecondary': 'rgba(255, 255, 255, 0.12)',
      'colorFillTertiary': 'rgba(255, 255, 255, 0.08)',
      'colorFillQuaternary': 'rgba(255, 255, 255, 0.04)',
      'red.3': '#58181c',
      'red.4': '#791a1f',
      'colorWhite': '#ffffff',
      'red.5': '#a61d24',
      'colorBgBase': '#000000',
      'red.6': '#d32029',
      'colorTextBase': '#ffffff',
      'red.7': '#e84749',
      'red.8': '#f37370',
      'colorBgContainerDisabled': 'rgba(255, 255, 255, 0.08)',
      'red.9': '#f89f9a',
      'colorBgTextActive': 'rgba(255, 255, 255, 0.18)',
      'red.10': '#fac8c3',
      'colorBgTextHover': 'rgba(255, 255, 255, 0.12)',
      'volcano.1': '#2b1611',
      'colorBorderBg': '#141414',
      'volcano.2': '#441d12',
      'colorFillContent': 'rgba(255, 255, 255, 0.12)',
      'volcano.3': '#592716',
      'colorFillContentHover': 'rgba(255, 255, 255, 0.18)',
      'volcano.4': '#7c3118',
      'colorFillAlter': 'rgba(255, 255, 255, 0.04)',
      'volcano.5': '#aa3e19',
      'volcano.6': '#d84a1b',
      'volcano.7': '#e87040',
      'transparent': 'rgba(255, 255, 255, 0)',
      'colorSplit': 'rgba(255, 255, 255, 0.06)',
      'yellow.1': '#2b2611',
      'volcano.8': '#f3956a',
      'yellow.2': '#443b11',
      'yellow.3': '#595014',
      'volcano.9': '#f8b692',
      'yellow.4': '#7c6e14',
      'volcano.10': '#fad4bc',
      'yellow.5': '#aa9514',
      'yellow.6': '#d8bd14',
      'yellow.7': '#e8d639',
      'yellow.8': '#f3ea62',
      'yellow.9': '#f8f48b',
      'yellow.10': '#fafab5',
      'colorPrimary': '#ffbc00',
      'colorSuccess': '#49aa19',
      'colorWarning': '#d89614',
      'colorInfo': '#ffbc00',
      'colorError': '#dc4446',
      'colorLink': '#ffbc00',
      'colorErrorBg': '#2c1618',
      'colorErrorBgHover': '#451d1f',
      'colorErrorBorder': '#5b2526',
      'colorErrorBorderHover': '#7e2e2f',
      'colorErrorHover': '#e86e6b',
      'colorErrorActive': '#ad393a',
      'colorErrorTextHover': '#e86e6b',
      'colorErrorText': '#dc4446',
      'colorErrorTextActive': '#ad393a',
      'colorLinkHover': '#e8bb27',
      'colorInfoBg': '#2c2311',
      'colorInfoBgHover': '#45350f',
      'colorInfoBorder': '#5b460e',
      'colorInfoBorderHover': '#e8bb27',
      'colorInfoHover': '#e8bb27',
      'colorInfoActive': '#ad8107',
      'colorInfoTextHover': '#e8bb27',
      'colorInfoText': '#dca203',
      'colorInfoTextActive': '#ad8107',
      'colorLinkActive': '#ad8107',
      'colorPrimaryBg': '#2c2311',
      'colorPrimaryBgHover': '#45350f',
      'colorPrimaryBorder': '#5b460e',
      'colorPrimaryBorderHover': '#7e5f0b',
      'colorPrimaryHover': '#e8bb27',
      'colorPrimaryActive': '#ad8107',
      'colorPrimaryTextHover': '#e8bb27',
      'colorPrimaryText': '#dca203',
      'colorPrimaryTextActive': '#ad8107',
      'colorSuccessBg': '#162312',
      'colorSuccessBgHover': '#1d3712',
      'colorSuccessBorder': '#274916',
      'colorSuccessBorderHover': '#306317',
      'colorSuccessHover': '#306317',
      'colorSuccessActive': '#3c8618',
      'colorSuccessTextHover': '#6abe39',
      'colorSuccessText': '#49aa19',
      'colorSuccessTextActive': '#3c8618',
      'colorWarningBg': '#2b2111',
      'colorWarningBgHover': '#443111',
      'colorWarningBorder': '#594214',
      'colorWarningBorderHover': '#7c5914',
      'colorWarningHover': '#7c5914',
      'colorWarningActive': '#aa7714',
      'colorWarningTextHover': '#e8b339',
      'colorWarningText': '#d89614',
      'colorWarningTextActive': '#aa7714',
      'colorErrorOutline': 'rgba(238, 38, 56, 0.11)',
      'colorWarningOutline': 'rgba(173, 107, 0, 0.15)',
      'controlItemBgActive': '#2c2311',
      'controlItemBgActiveDisabled': 'rgba(255, 255, 255, 0.18)',
      'controlItemBgActiveHover': '#45350f',
      'controlItemBgHover': 'rgba(255, 255, 255, 0.08)',
      'controlOutline': 'rgba(255, 188, 0, 0.1)',
      'controlTmpOutline': 'rgba(255, 255, 255, 0.04)',
      'borderRadius': 4,
      'borderRadiusLG': 4,
      'borderRadiusSM': 4,
      'borderRadiusXS': 2,
      'sizeStep': 4,
      'sizeUnit': 4,
      'controlInteractiveSize': 16,
      'size': 16,
      'sizeLG': 24,
      'sizeMD': 20,
      'sizeMS': 16,
      'sizeSM': 12,
      'sizeXL': 32,
      'sizeXS': 8,
      'sizeXXL': 48,
      'controlHeight': 32,
      'sizeXXS': 4,
      'controlHeightLG': 40,
      'controlHeightSM': 24,
      'controlHeightXS': 16,
      'lineWidth': 1,
      'lineWidthBold': 2,
      'lineWidthFocus': 4,
      'controlOutlineWidth': 2,
      'screenLG': 992,
      'screenLGMax': 1199,
      'screenLGMin': 992,
      'screenMD': 768,
      'screenMDMax': 991,
      'screenMDMin': 768,
      'screenSM': 576,
      'screenSMMax': 767,
      'screenSMMin': 576,
      'screenXL': 1200,
      'screenXLMax': 1599,
      'screenXLMin': 1200,
      'screenXS': 480,
      'screenXSMax': 575,
      'screenXSMin': 480,
      'screenXXL': 1600,
      'screenXXLMin': 1600,
      'sizePopupArrow': 16,
      'margin': 16,
      'marginLG': 24,
      'marginMD': 20,
      'marginSM': 12,
      'marginXL': 32,
      'marginXS': 8,
      'marginXXL': 48,
      'marginXXS': 4,
      'padding': 16,
      'paddingLG': 24,
      'paddingMD': 20,
      'paddingSM': 12,
      'paddingXL': 32,
      'paddingXS': 8,
      'paddingXXS': 4,
      'paddingContentHorizontal': 16,
      'paddingContentHorizontalLG': 24,
      'paddingContentHorizontalSM': 16,
      'paddingContentVertical': 12,
      'paddingContentVerticalLG': 16,
      'paddingContentVerticalSM': 8,
      'controlPaddingHorizontal': 12,
      'controlPaddingHorizontalSM': 8,
      'fontFamily': 'DM Sans',
      'fontFamilyCode': 'Courier Prime',
      'fontSize': 14,
      'fontSizeLG': 16,
      'fontSizeSM': 12,
      'fontSizeXL': 20,
      'fontSizeHeading1': 38,
      'fontSizeHeading2': 30,
      'fontSizeHeading3': 24,
      'fontSizeHeading4': 20,
      'fontSizeHeading5': 16,
      'lineHeight': 1.5714285714285714,
      'lineHeightHeading1': 1.2105263157894737,
      'lineHeightHeading2': 1.2666666666666666,
      'lineHeightHeading3': 1.3333333333333333,
      'lineHeightHeading4': 1.4,
      'lineHeightHeading5': 1.5,
      'lineHeightLG': 1.5,
      'lineHeightSM': 1.6666666666666667,
      'fontSizeIcon': 12,
      'fontWeightStrong': 600,
      'colorFillAlterSolid': '#1d1d1d',
      'fontWeightNormal': 400,
      'colorFilledHandleBg': '#303030',
      'colorBgSolid': 'rgba(255, 255, 255, 0.95)',
      'colorBgSolidActive': 'rgba(255, 255, 255, 0.9)',
      'colorBgSolidHover': '#ffffff',
      'solidTextColor': '#000000',
      'pink.1': '#291321',
      'pink.2': '#40162f',
      'pink.3': '#551c3b',
      'pink.4': '#75204f',
      'pink.5': '#a02669',
      'pink.6': '#cb2b83',
      'pink.7': '#e0529c',
      'pink.8': '#f37fb7',
      'pink.9': '#f8a8cc',
      'pink.10': '#fad2e3'
    },
    components: {
      Input: {
        paddingInlineSM: 7,
        paddingInlineLG: 11,
        paddingInline: 11,
        paddingBlockSM: 0,
        paddingBlockLG: 7,
        paddingBlock: 4,
        paddingXXS: 4,
        paddingXS: 8,
        paddingSM: 12,
        paddingLG: 24,
        lineWidth: 1,
        lineHeightLG: 1.5,
        lineHeight: 1.5714285714285714,
        fontSizeLG: 16,
        fontSizeIcon: 12,
        fontSize: 14,
        controlPaddingHorizontalSM: 8,
        controlPaddingHorizontal: 12,
        controlOutlineWidth: 2,
        controlOutline: 'rgba(255, 188, 0, 0.1)',
        controlHeightSM: 24,
        controlHeightLG: 40,
        controlHeight: 32,

        colorWarningOutline: 'rgba(173, 107, 0, 0.15)',
        colorWarningBorderHover: '#7c5914',
        colorWarning: '#d89614',
        colorTextTertiary: 'rgba(255, 255, 255, 0.45)',
        colorTextQuaternary: 'rgba(255, 255, 255, 0.25)',
        colorTextPlaceholder: 'rgba(255, 255, 255, 0.25)',
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorTextDescription: 'rgba(255, 255, 255, 0.45)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorPrimary: '#ffbc00',
        colorIconHover: 'rgba(255, 255, 255, 0.85)',
        colorIcon: 'rgba(255, 255, 255, 0.45)',
        colorFillAlter: 'rgba(255, 255, 255, 0.04)',
        colorErrorOutline: 'rgba(238, 38, 56, 0.11)',
        colorErrorBorderHover: '#7e2e2f',
        colorError: '#dc4446',
        colorBorder: '#424242',
        colorBgContainerDisabled: 'rgba(255, 255, 255, 0.08)',
        colorBgContainer: '#141414',
        hoverBorderColor: '#e8bb27',
        addonBg: 'rgba(255, 255, 255, 0.04)',
        activeBorderColor: '#ffbc00',
        colorFillTertiary: 'rgba(255, 255, 255, 0.08)',
        colorFillSecondary: 'rgba(255, 255, 255, 0.12)',
        colorErrorBgHover: '#451d1f',
        colorErrorBg: '#2c1618',
        colorWarningBg: '#2b2111',
        colorWarningBgHover: '#443111',
        colorWarningText: '#d89614',
        colorErrorText: '#dc4446',
        activeBg: '#141414',
        hoverBg: '#141414',
        inputFontSize: 14,
        inputFontSizeLG: 16,
        inputFontSizeSM: 12,
        fontFamily: 'DM Sans'
      },
      Transfer: {
        listWidthLG: 250,
        listWidth: 180,
        listHeight: 200,
        itemPaddingBlock: 5,
        paddingXS: 8,
        paddingSM: 12,
        marginXXS: 4,
        marginXS: 8,
        margin: 16,
        lineWidth: 1,
        lineHeight: 1.5714285714285714,
        fontSizeIcon: 12,
        fontSize: 14,
        controlItemBgHover: 'rgba(255, 255, 255, 0.08)',
        controlItemBgActiveHover: '#45350f',
        controlItemBgActive: '#2c2311',
        controlHeightLG: 40,
        controlHeight: 32,
        borderRadiusLG: 8,
        colorWarning: '#d89614',
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorSplit: 'rgba(255, 255, 255, 0.06)',
        colorLinkHover: '#e8bb27',
        colorError: '#dc4446',
        colorBorder: '#424242',
        colorBgContainerDisabled: 'rgba(255, 255, 255, 0.08)',
        colorBgContainer: '#141414',
        itemHeight: 32,
        headerHeight: 40,
        fontFamily: 'DM Sans'
      },
      Segmented: {
        segmentedBgColorSelected: '#ffffff',
        paddingXXS: 4,
        marginSM: 12,
        lineWidthBold: 2,
        lineWidth: 1,
        lineHeight: 1.5714285714285714,
        fontSizeLG: 16,
        fontSize: 14,
        controlPaddingHorizontalSM: 8,
        controlPaddingHorizontal: 12,
        controlHeightSM: 24,
        controlHeightLG: 40,
        controlHeight: 32,

        colorTextLabel: 'rgba(255, 255, 255, 0.65)',
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorFillSecondary: 'rgba(255, 255, 255, 0.12)',
        colorFill: 'rgba(255, 255, 255, 0.18)',
        colorBgLayout: '#000000',
        colorBgElevated: '#1f1f1f',
        segmentedGroupBg: 'rgba(255, 255, 255, 0.08)',
        itemSelectedColor: 'rgba(255, 255, 255, 0.85)',
        itemSelectedBg: '#1f1f1f',
        itemHoverColor: 'rgba(255, 255, 255, 0.85)',
        itemHoverBg: 'rgba(255, 255, 255, 0.12)',
        itemColor: 'rgba(255, 255, 255, 0.65)',
        itemActiveBg: 'rgba(255, 255, 255, 0.18)',
        trackPadding: 2,
        trackBg: '#000000',
        fontFamily: 'DM Sans'
      },
      Switch: {
        trackPadding: 2,
        trackMinWidthSM: 28,
        trackMinWidth: 44,
        trackHeightSM: 16,
        trackHeight: 22,
        handleSizeSM: 12,
        handleSize: 18,
        marginXXS: 4,
        lineWidthFocus: 4,
        lineHeight: 1.5714285714285714,
        fontSizeSM: 12,
        fontSizeIcon: 12,
        fontSize: 14,
        controlHeight: 32,
        colorWhite: '#ffffff',
        colorTextTertiary: 'rgba(255, 255, 255, 0.45)',
        colorTextQuaternary: 'rgba(255, 255, 255, 0.25)',
        colorTextLightSolid: '#ffffff',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorPrimaryHover: '#e8bb27',
        colorPrimaryBorder: '#5b460e',
        colorPrimary: '#ffbc00',
        handleBg: '#ffffff',
        fontFamily: 'DM Sans'
      },
      TimePicker: {
        timeColumnWidth: 56,
        timeColumnHeight: 224,
        timeCellHeight: 28,

        sizePopupArrow: 16,
        paddingXXS: 4,
        paddingXS: 8,
        paddingSM: 12,
        padding: 16,
        marginXXS: 4,
        marginXS: 8,
        lineWidthBold: 2,
        lineWidth: 1,
        lineHeightLG: 1.5,
        lineHeight: 1.5714285714285714,
        fontWeightStrong: 600,
        fontSizeLG: 16,
        fontSize: 14,
        controlPaddingHorizontalSM: 8,
        controlPaddingHorizontal: 12,
        controlOutlineWidth: 2,
        controlOutline: 'rgba(255, 188, 0, 0.1)',
        controlItemBgHover: 'rgba(255, 255, 255, 0.08)',
        controlItemBgActive: '#2c2311',
        controlHeightSM: 24,
        controlHeightLG: 40,
        controlHeight: 32,

        colorWarningOutline: 'rgba(173, 107, 0, 0.15)',
        colorWarning: '#d89614',
        colorTextQuaternary: 'rgba(255, 255, 255, 0.25)',
        colorTextPlaceholder: 'rgba(255, 255, 255, 0.25)',
        colorTextLightSolid: '#ffffff',
        colorTextHeading: 'rgba(255, 255, 255, 0.85)',
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorTextDescription: 'rgba(255, 255, 255, 0.45)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorSplit: 'rgba(255, 255, 255, 0.06)',
        colorPrimaryHover: '#e8bb27',
        colorPrimaryBorder: '#5b460e',
        colorPrimary: '#ffbc00',
        colorLinkHover: '#e8bb27',
        colorLinkActive: '#ad8107',
        colorLink: '#ffbc00',
        colorIconHover: 'rgba(255, 255, 255, 0.85)',
        colorIcon: 'rgba(255, 255, 255, 0.45)',
        colorFillAlter: 'rgba(255, 255, 255, 0.04)',
        colorErrorOutline: 'rgba(238, 38, 56, 0.11)',
        colorError: '#dc4446',
        colorBorder: '#424242',
        colorBgElevated: '#1f1f1f',
        colorBgContainerDisabled: 'rgba(255, 255, 255, 0.08)',
        colorBgContainer: '#141414',
        hoverBorderColor: '#e8bb27',
        cellHoverBg: 'rgba(255, 255, 255, 0.08)',
        cellHeight: 24,
        activeBorderColor: '#ffbc00',
        paddingInline: 11,
        paddingInlineLG: 11,
        paddingInlineSM: 7,
        activeBg: '#141414',
        hoverBg: '#141414',
        cellBgDisabled: 'rgba(255, 255, 255, 0.08)',
        cellActiveWithRangeBg: '#2c2311',
        cellHoverWithRangeBg: '#c8dfff',
        cellRangeBorderColor: '#7cb3ff',
        multipleItemBg: 'rgba(255, 255, 255, 0.12)',
        multipleItemBorderColor: 'rgba(255, 255, 255, 0)',
        multipleItemBorderColorDisabled: 'rgba(255, 255, 255, 0)',
        multipleItemColorDisabled: 'rgba(255, 255, 255, 0.25)',
        multipleSelectorBgDisabled: 'rgba(255, 255, 255, 0.08)',
        cellWidth: 36,
        multipleItemHeight: 24,
        multipleItemHeightLG: 32,
        multipleItemHeightSM: 16,
        paddingBlock: 4,
        paddingBlockLG: 7,
        paddingBlockSM: 0,
        presetsMaxWidth: 200,
        presetsWidth: 120,
        textHeight: 40,
        withoutTimeCellHeight: 66,
        inputFontSize: 14,
        inputFontSizeLG: 16,
        inputFontSizeSM: 12,
        fontFamily: 'DM Sans',
        colorFillSecondary: 'rgba(255, 255, 255, 0.12)',
        colorFillTertiary: 'rgba(255, 255, 255, 0.08)'
      },
      Timeline: {
        itemPaddingBottom: 20,
        paddingXXS: 4,
        padding: 16,
        marginXXS: 4,
        marginXS: 8,
        marginSM: 12,
        margin: 16,
        lineWidthBold: 2,
        lineWidth: 1,
        lineHeight: 1.5714285714285714,
        fontSizeSM: 12,
        fontSize: 14,
        controlHeightLG: 40,
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorSuccess: '#49aa19',
        colorPrimary: '#ffbc00',
        colorError: '#dc4446',
        colorBgContainer: '#141414',
        tailColor: 'rgba(255, 255, 255, 0.06)',
        dotBg: '#141414',
        fontFamily: 'DM Sans'
      },
      Tabs: {
        horizontalItemGutter: 32,
        cardGutter: 2,
        paddingXXS: 4,
        paddingXS: 8,
        paddingSM: 12,
        paddingLG: 24,
        padding: 16,
        marginXXS: 4,
        marginXS: 8,
        marginSM: 12,
        margin: 16,
        lineWidthFocus: 4,
        lineWidthBold: 2,
        lineWidth: 1,
        lineHeight: 1.5714285714285714,
        fontSizeSM: 12,
        fontSizeLG: 16,
        fontSize: 14,
        controlItemBgHover: 'rgba(255, 255, 255, 0.08)',
        controlHeightLG: 40,
        controlHeight: 32,

        colorTextHeading: 'rgba(255, 255, 255, 0.85)',
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorTextDescription: 'rgba(255, 255, 255, 0.45)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorPrimaryHover: '#e8bb27',
        colorPrimaryBorder: '#5b460e',
        colorPrimaryActive: '#ad8107',
        colorPrimary: '#ffbc00',
        colorFillAlter: 'rgba(255, 255, 255, 0.04)',
        colorBorderSecondary: '#303030',
        colorBorder: '#424242',
        colorBgContainer: '#141414',
        itemSelectedColor: '#ffbc00',
        itemHoverColor: '#e8bb27',
        itemColor: 'rgba(255, 255, 255, 0.85)',
        itemActiveColor: '#ad8107',
        inkBarColor: '#ffbc00',
        cardHeight: 40,
        cardBg: 'rgba(255, 255, 255, 0.04)',
        titleFontSize: 14,
        titleFontSizeLG: 16,
        titleFontSizeSM: 14,
        fontFamily: 'DM Sans'
      },
      Table: {
        stickyScrollBarBorderRadius: 100,
        headerSplitColor: '#303030',
        headerBg: 'rgba(255, 255, 255, 0.04)',
        footerBg: 'rgba(255, 255, 255, 0.04)',
        paddingXXS: 4,
        paddingXS: 8,
        paddingSM: 12,
        padding: 16,
        marginXXS: 4,
        margin: 16,
        lineWidth: 1,
        lineHeight: 1.5714285714285714,
        fontWeightStrong: 600,
        fontSizeSM: 12,
        fontSizeIcon: 12,
        fontSize: 14,
        controlItemBgHover: 'rgba(255, 255, 255, 0.08)',
        controlItemBgActiveHover: '#45350f',
        controlItemBgActive: '#2c2311',
        controlInteractiveSize: 16,
        controlHeight: 32,

        colorTextPlaceholder: 'rgba(255, 255, 255, 0.25)',
        colorTextHeading: 'rgba(255, 255, 255, 0.85)',
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorTextDescription: 'rgba(255, 255, 255, 0.45)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorSplit: 'rgba(255, 255, 255, 0.06)',
        colorPrimary: '#ffbc00',
        colorLinkHover: '#e8bb27',
        colorLinkActive: '#ad8107',
        colorLink: '#ffbc00',
        colorIconHover: 'rgba(255, 255, 255, 0.85)',
        colorIcon: 'rgba(255, 255, 255, 0.45)',
        colorFillSecondary: 'rgba(255, 255, 255, 0.12)',
        colorFillContent: 'rgba(255, 255, 255, 0.12)',
        colorFillAlter: 'rgba(255, 255, 255, 0.04)',
        colorBorderSecondary: '#303030',
        colorBgContainer: '#141414',
        rowSelectedHoverBg: '#45350f',
        headerFilterHoverBg: 'rgba(255, 255, 255, 0.12)',
        headerColor: 'rgba(255, 255, 255, 0.85)',
        headerBorderRadius: 8,
        footerColor: 'rgba(255, 255, 255, 0.85)',
        filterDropdownMenuBg: '#141414',
        filterDropdownBg: '#141414',
        cellPaddingInlineSM: 8,
        cellPaddingInlineMD: 8,
        cellPaddingInline: 16,
        cellPaddingBlockSM: 8,
        cellPaddingBlockMD: 12,
        cellPaddingBlock: 16,
        borderColor: '#303030',
        rowHoverBg: '#1d1d1d',
        headerSortActiveBg: 'rgba(255, 255, 255, 0.12)',
        bodySortBg: '#1d1d1d',
        headerSortHoverBg: 'rgba(255, 255, 255, 0.12)',
        cellFontSize: 14,
        cellFontSizeMD: 14,
        cellFontSizeSM: 14,
        fontFamily: 'DM Sans'
      },
      Steps: {
        dotSize: 8,
        dotCurrentSize: 10,
        descriptionMaxWidth: 140,
        paddingXXS: 4,
        paddingXS: 8,
        paddingSM: 12,
        paddingLG: 24,
        padding: 16,
        marginXXS: 4,
        marginXS: 8,
        marginSM: 12,
        marginLG: 24,
        margin: 16,
        lineWidthFocus: 4,
        lineWidthBold: 2,
        lineWidth: 1,
        lineHeightSM: 1.6666666666666667,
        lineHeight: 1.5714285714285714,
        fontWeightStrong: 600,
        fontSizeSM: 12,
        fontSizeLG: 16,
        fontSizeIcon: 12,
        fontSizeHeading3: 24,
        fontSize: 14,
        controlItemBgHover: 'rgba(255, 255, 255, 0.08)',
        controlItemBgActive: '#2c2311',
        controlHeightLG: 40,

        colorTextQuaternary: 'rgba(255, 255, 255, 0.25)',
        colorTextLightSolid: '#ffffff',
        colorTextLabel: 'rgba(255, 255, 255, 0.65)',
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorTextDescription: 'rgba(255, 255, 255, 0.45)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorSplit: 'rgba(255, 255, 255, 0.06)',
        colorPrimaryBorder: '#5b460e',
        colorPrimary: '#ffbc00',
        colorFillContent: 'rgba(255, 255, 255, 0.12)',
        colorError: '#dc4446',
        colorBorderSecondary: '#303030',
        colorBorderBg: '#141414',
        colorBgContainer: '#141414',
        titleLineHeight: 32,
        iconSizeSM: 24,
        iconSize: 32,
        finishIconBorderColor: '#1677ff',
        customIconFontSize: 24,
        iconFontSize: 14,
        fontFamily: 'DM Sans'
      },
      Spin: {
        dotSizeSM: 14,
        dotSize: 20,
        contentHeight: 400,
        marginXXS: 4,
        lineHeight: 1.5714285714285714,
        fontSize: 14,
        controlHeightLG: 40,
        controlHeight: 32,
        colorTextDescription: 'rgba(255, 255, 255, 0.45)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorPrimary: '#ffbc00',
        colorBgContainer: '#141414',
        dotSizeLG: 32,
        fontFamily: 'DM Sans'
      },
      Slider: {
        railSize: 4,
        handleSizeHover: 12,
        dotSize: 8,
        controlSize: 10,
        handleSize: 10,
        lineWidth: 1,
        lineHeight: 1.5714285714285714,
        fontSize: 14,
        controlHeightSM: 24,
        controlHeightLG: 40,
        controlHeight: 32,
        borderRadiusXS: 2,
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorTextDescription: 'rgba(255, 255, 255, 0.45)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorPrimaryBorderHover: '#7e5f0b',
        colorPrimaryBorder: '#5b460e',
        colorPrimary: '#ffbc00',
        colorFillTertiary: 'rgba(255, 255, 255, 0.08)',
        colorFillSecondary: 'rgba(255, 255, 255, 0.12)',
        colorFillContentHover: 'rgba(255, 255, 255, 0.18)',
        colorBorderSecondary: '#303030',
        colorBgElevated: '#1f1f1f',
        colorBgContainerDisabled: 'rgba(255, 255, 255, 0.08)',
        colorBgContainer: '#141414',
        trackHoverBg: '#7e5f0b',
        trackBgDisabled: 'rgba(255, 255, 255, 0.08)',
        trackBg: '#5b460e',
        railHoverBg: 'rgba(255, 255, 255, 0.12)',
        railBg: 'rgba(255, 255, 255, 0.08)',
        handleColor: '#5b460e',
        handleActiveColor: '#ffbc00',
        dotBorderColor: '#303030',
        dotActiveBorderColor: '#5b460e',
        handleColorDisabled: '#bfbfbf',
        fontFamily: 'DM Sans'
      },
      Rate: {
        rateStarSize: 20,
        marginXS: 8,
        lineWidth: 1,
        lineHeight: 1.5714285714285714,
        fontSize: 14,
        controlHeightLG: 40,
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorFillContent: 'rgba(255, 255, 255, 0.12)',
        fontFamily: 'DM Sans'
      },
      Radio: {
        radioSize: 16,
        dotSize: 8,
        buttonPaddingInline: 15,
        paddingXS: 8,
        padding: 16,
        marginXS: 8,
        lineWidthFocus: 4,
        lineWidth: 1,
        lineHeight: 1.5714285714285714,
        fontSizeLG: 16,
        fontSize: 14,
        controlOutlineWidth: 2,
        controlOutline: 'rgba(255, 188, 0, 0.1)',
        controlItemBgActiveDisabled: 'rgba(255, 255, 255, 0.18)',
        controlHeightSM: 24,
        controlHeightLG: 40,
        controlHeight: 32,

        colorWhite: '#ffffff',
        colorTextLightSolid: '#ffffff',
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorPrimaryHover: '#e8bb27',
        colorPrimaryBorder: '#5b460e',
        colorPrimaryActive: '#ad8107',
        colorPrimary: '#ffbc00',
        colorBorder: '#424242',
        colorBgContainerDisabled: 'rgba(255, 255, 255, 0.08)',
        colorBgContainer: '#141414',
        wrapperMarginInlineEnd: 8,
        dotColorDisabled: 'rgba(255, 255, 255, 0.25)',
        buttonSolidCheckedHoverBg: '#e8bb27',
        buttonSolidCheckedColor: '#ffffff',
        buttonSolidCheckedBg: '#ffbc00',
        buttonSolidCheckedActiveBg: '#ad8107',
        buttonColor: 'rgba(255, 255, 255, 0.85)',
        buttonCheckedColorDisabled: 'rgba(255, 255, 255, 0.25)',
        buttonCheckedBgDisabled: 'rgba(255, 255, 255, 0.18)',
        buttonCheckedBg: '#141414',
        buttonBg: '#141414',
        fontFamily: 'DM Sans',
        radioBgColor: '#ffbc00',
        radioColor: '#ffffff'
      },
      Popover: {
        titleMinWidth: 177,
        sizePopupArrow: 16,
        paddingSM: 12,
        padding: 16,
        marginXS: 8,
        lineWidth: 1,
        lineHeight: 1.5714285714285714,
        fontWeightStrong: 600,
        fontSize: 14,
        controlHeight: 32,

        colorTextHeading: 'rgba(255, 255, 255, 0.85)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorSplit: 'rgba(255, 255, 255, 0.06)',
        colorBgElevated: '#1f1f1f',
        fontFamily: 'DM Sans'
      },
      Notification: {
        width: 384,
        paddingMD: 20,
        paddingLG: 24,
        paddingContentHorizontalLG: 24,
        marginXS: 8,
        marginSM: 12,
        marginLG: 24,
        margin: 16,
        lineHeight: 1.5714285714285714,
        fontSizeLG: 16,
        fontSize: 14,
        controlHeightLG: 40,

        colorWarning: '#d89614',
        colorTextHeading: 'rgba(255, 255, 255, 0.85)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorSuccess: '#49aa19',
        colorInfo: '#ffbc00',
        colorIconHover: 'rgba(255, 255, 255, 0.85)',
        colorIcon: 'rgba(255, 255, 255, 0.45)',
        colorError: '#dc4446',
        colorBgElevated: '#1f1f1f',
        lineHeightLG: 1.5,
        lineWidthFocus: 4,
        fontFamily: 'DM Sans'
      },
      Tooltip: {
        paddingSM: 12,
        sizePopupArrow: 16,
        paddingXS: 8,
        lineHeight: 1.5714285714285714,
        fontSize: 14,
        controlHeight: 32,

        colorTextLightSolid: '#ffffff',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorBgSpotlight: '#424242',
        fontFamily: 'DM Sans'
      },
      Menu: {
        subMenuItemBg: 'rgba(0, 0, 0, 0.02)',
        darkSubMenuItemBg: '#000c17',
        darkItemDisabledColor: 'rgba(255, 255, 255, 0.25)',
        darkItemColor: 'rgba(255, 255, 255, 0.65)',
        darkGroupTitleColor: 'rgba(255, 255, 255, 0.65)',
        darkItemBg: '#001529',
        paddingXS: 8,
        paddingXL: 32,
        padding: 16,
        marginXXS: 4,
        marginXS: 8,
        margin: 16,
        lineWidthFocus: 4,
        lineWidthBold: 2,
        lineWidth: 1,
        lineHeight: 1.5714285714285714,
        fontSizeLG: 16,
        fontSize: 14,
        controlItemBgActive: '#2c2311',
        controlHeightSM: 24,
        controlHeightLG: 40,

        colorSplit: 'rgba(255, 255, 255, 0.06)',
        colorPrimaryBorder: '#5b460e',
        colorPrimary: '#ffbc00',
        colorFillContent: 'rgba(255, 255, 255, 0.12)',
        colorErrorHover: '#e86e6b',
        colorErrorBg: '#2c1618',
        colorError: '#dc4446',
        colorBgElevated: '#1f1f1f',
        colorBgContainer: '#141414',
        subMenuItemBorderRadius: 4,
        popupBg: '#1f1f1f',
        itemSelectedColor: '#ffbc00',
        itemSelectedBg: '#2c2311',
        itemHoverColor: 'rgba(255, 255, 255, 0.85)',
        itemHoverBg: 'rgba(255, 255, 255, 0.12)',
        itemHeight: 40,
        itemDisabledColor: 'rgba(255, 255, 255, 0.25)',
        itemColor: 'rgba(255, 255, 255, 0.85)',
        itemBorderRadius: 8,
        itemBg: '#141414',
        iconSize: 14,
        horizontalItemSelectedColor: '#ffbc00',
        horizontalItemSelectedBg: 'rgba(255, 255, 255, 0)',
        horizontalItemHoverColor: '#ffbc00',
        horizontalItemHoverBg: 'rgba(255, 255, 255, 0)',
        groupTitleColor: 'rgba(255, 255, 255, 0.45)',
        darkItemSelectedColor: '#ffffff',
        darkItemSelectedBg: '#ffbc00',
        darkItemHoverColor: '#ffffff',
        darkItemHoverBg: 'rgba(255, 255, 255, 0)',
        collapsedIconSize: 16,
        darkPopupBg: '#001529',
        activeBarBorderWidth: 1,
        collapsedWidth: 80,
        dropdownWidth: 160,
        itemMarginBlock: 4,
        itemMarginInline: 4,
        iconMarginInlineEnd: 10,
        groupTitleFontSize: 14,
        groupTitleLineHeight: 1.5714285714285714,
        fontFamily: 'DM Sans',
        subMenuItemSelectedColor: '#ffbc00'
      },
      InputNumber: {
        paddingInlineSM: 7,
        paddingInlineLG: 11,
        paddingInline: 11,
        paddingBlockSM: 0,
        paddingBlockLG: 7,
        paddingBlock: 4,
        handleWidth: 22,
        controlWidth: 90,
        paddingXXS: 4,
        paddingXS: 8,
        paddingSM: 12,
        lineWidth: 1,
        lineHeightLG: 1.5,
        lineHeight: 1.5714285714285714,
        fontSizeLG: 16,
        fontSize: 14,
        controlPaddingHorizontalSM: 8,
        controlPaddingHorizontal: 12,
        controlHeightSM: 24,
        controlHeightLG: 40,
        controlHeight: 32,

        colorWarningBorderHover: '#7c5914',
        colorWarning: '#d89614',
        colorTextPlaceholder: 'rgba(255, 255, 255, 0.25)',
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorTextDescription: 'rgba(255, 255, 255, 0.45)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorPrimaryHover: '#e8bb27',
        colorPrimary: '#ffbc00',
        colorFillAlter: 'rgba(255, 255, 255, 0.04)',
        colorErrorBorderHover: '#7e2e2f',
        colorError: '#dc4446',
        colorBorder: '#424242',
        colorBgContainerDisabled: 'rgba(255, 255, 255, 0.08)',
        colorBgContainer: '#141414',
        hoverBorderColor: '#e8bb27',
        handleHoverColor: '#ffbc00',
        handleBorderColor: '#424242',
        handleBg: '#141414',
        handleActiveBg: 'rgba(255, 255, 255, 0.04)',
        addonBg: 'rgba(255, 255, 255, 0.04)',
        activeBorderColor: '#ffbc00',
        activeBg: '#141414',
        hoverBg: '#141414',
        inputFontSize: 14,
        inputFontSizeLG: 16,
        inputFontSizeSM: 12,
        fontFamily: 'DM Sans',
        colorTextQuaternary: 'rgba(255, 255, 255, 0.25)',
        colorFillSecondary: 'rgba(255, 255, 255, 0.12)',
        colorFillTertiary: 'rgba(255, 255, 255, 0.08)',
        colorWarningBg: '#2b2111',
        colorWarningBgHover: '#443111',
        colorErrorBg: '#2c1618',
        colorErrorBgHover: '#451d1f',
        filledHandleBg: '#303030',
        colorErrorText: '#dc4446',
        colorWarningText: '#d89614'
      },
      Image: {
        previewOperationSize: 18,
        previewOperationHoverColor: 'rgba(255, 255, 255, 0.85)',
        previewOperationColorDisabled: 'rgba(255, 255, 255, 0.25)',
        previewOperationColor: 'rgba(255, 255, 255, 0.65)',
        paddingXXS: 4,
        paddingSM: 12,
        paddingLG: 24,
        marginXXS: 4,
        marginXL: 32,
        marginSM: 12,
        margin: 16,
        fontSizeIcon: 12,
        controlHeightLG: 40,
        colorTextLightSolid: '#ffffff',
        colorBgMask: 'rgba(0, 0, 0, 0.45)',
        colorBgContainerDisabled: 'rgba(255, 255, 255, 0.08)'
      },
      Card: {
        headerHeightSM: 38,
        headerHeight: 56,
        paddingXS: 8,
        paddingSM: 12,
        paddingLG: 24,
        padding: 16,
        marginXXS: 4,
        marginXS: 8,
        lineWidth: 1,
        lineHeightLG: 1.5,
        lineHeight: 1.5714285714285714,
        fontWeightStrong: 600,
        fontSize: 14,
        borderRadiusLG: 8,
        colorTextHeading: 'rgba(255, 255, 255, 0.85)',
        colorTextDescription: 'rgba(255, 255, 255, 0.45)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorPrimary: '#ffbc00',
        colorFillAlter: 'rgba(255, 255, 255, 0.04)',
        colorBorderSecondary: '#303030',
        colorBgContainer: '#141414',
        headerBg: 'rgba(255, 255, 255, 0)',
        headerFontSize: 16,
        headerFontSizeSM: 14,
        fontHeight: 22,
        fontSizeLG: 16,
        fontFamily: 'DM Sans',
        bodyPaddingSM: 12,
        headerPaddingSM: 12,
        bodyPadding: 24,
        headerPadding: 24
      },
      Carousel: {
        dotWidth: 16,
        dotHeight: 3,
        dotActiveWidth: 24,
        marginXXS: 4,
        lineHeight: 1.5714285714285714,
        fontSize: 14,
        controlHeightSM: 24,
        controlHeightLG: 40,
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorBgContainer: '#141414',
        fontFamily: 'DM Sans'
      },
      Cascader: {
        dropdownHeight: 180,
        controlWidth: 184,
        controlItemWidth: 111,
        paddingXXS: 4,
        paddingXS: 8,
        paddingSM: 12,
        marginXS: 8,
        lineWidthFocus: 4,
        lineWidthBold: 2,
        lineWidth: 1,
        lineHeight: 1.5714285714285714,
        fontWeightStrong: 600,
        fontSizeLG: 16,
        fontSizeIcon: 12,
        fontSize: 14,
        controlItemBgHover: 'rgba(255, 255, 255, 0.08)',
        controlItemBgActive: '#2c2311',
        controlInteractiveSize: 16,
        controlHeight: 32,

        colorWhite: '#ffffff',
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorTextDescription: 'rgba(255, 255, 255, 0.45)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorSplit: 'rgba(255, 255, 255, 0.06)',
        colorPrimaryHover: '#e8bb27',
        colorPrimaryBorder: '#5b460e',
        colorPrimary: '#ffbc00',
        colorBorder: '#424242',
        colorBgContainerDisabled: 'rgba(255, 255, 255, 0.08)',
        colorBgContainer: '#141414',
        optionSelectedBg: '#2c2311',
        menuPadding: 4,
        optionSelectedFontWeight: 600,
        fontFamily: 'DM Sans',

        optionSelectedColor: 'rgba(255, 255, 255, 0.85)'
      },
      Calendar: {
        yearControlWidth: 80,
        monthControlWidth: 70,
        controlHeight: 32,
        screenXS: 480,
        paddingXXS: 4,
        paddingXS: 8,
        paddingSM: 12,
        padding: 16,
        marginXXS: 4,
        marginXS: 8,
        lineWidthBold: 2,
        lineWidth: 1,
        lineHeightSM: 1.6666666666666667,
        lineHeight: 1.5714285714285714,
        fontWeightStrong: 600,
        fontSizeSM: 12,
        fontSize: 14,
        controlItemBgHover: 'rgba(255, 255, 255, 0.08)',
        controlItemBgActive: '#2c2311',
        controlHeightSM: 24,
        controlHeightLG: 40,
        borderRadiusSM: 4,
        borderRadiusLG: 8,
        colorTextLightSolid: '#ffffff',
        colorTextHeading: 'rgba(255, 255, 255, 0.85)',
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorSplit: 'rgba(255, 255, 255, 0.06)',
        colorPrimary: '#ffbc00',
        colorLinkHover: '#e8bb27',
        colorLinkActive: '#ad8107',
        colorLink: '#ffbc00',
        colorIconHover: 'rgba(255, 255, 255, 0.85)',
        colorIcon: 'rgba(255, 255, 255, 0.45)',
        colorBgContainerDisabled: 'rgba(255, 255, 255, 0.08)',
        colorBgContainer: '#141414',
        itemActiveBg: '#2c2311',
        fullPanelBg: '#141414',
        fullBg: '#141414',
        fontHeightSM: 20,
        fontFamily: 'DM Sans'
      },
      Button: {
        paddingInlineSM: 7,
        paddingInlineLG: 15,
        paddingInline: 15,
        onlyIconSizeSM: 14,
        onlyIconSizeLG: 18,
        paddingXS: 8,
        paddingContentHorizontal: 16,
        marginXS: 8,
        lineWidthFocus: 4,
        lineWidth: 1,
        contentLineHeight: 1.5714285714285714,
        contentFontSizeLG: 16,
        contentFontSize: 14,
        controlOutlineWidth: 2,
        controlOutline: 'rgba(255, 188, 0, 0.1)',
        controlHeightSM: 24,
        controlHeightLG: 40,
        controlHeight: 32,
        borderRadiusSM: 4,
        borderRadiusLG: 8,

        colorTextLightSolid: '#ffffff',
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorPrimaryHover: '#e8bb27',
        colorPrimaryBorder: '#5b460e',
        colorPrimaryActive: '#ad8107',
        colorPrimary: '#ffbc00',
        colorLinkHover: '#e8bb27',
        colorLinkActive: '#ad8107',
        colorLink: '#ffbc00',
        colorErrorOutline: 'rgba(238, 38, 56, 0.11)',
        colorErrorHover: '#e86e6b',
        colorErrorBorderHover: '#7e2e2f',
        colorErrorBg: '#2c1618',
        colorErrorActive: '#ad393a',
        colorError: '#dc4446',
        colorBorder: '#424242',
        colorBgTextActive: 'rgba(255, 255, 255, 0.18)',
        colorBgContainerDisabled: 'rgba(255, 255, 255, 0.08)',
        colorBgContainer: '#141414',
        textHoverBg: 'rgba(255, 255, 255, 0.12)',
        primaryColor: '#000000',
        onlyIconSize: 16,
        linkHoverBg: 'rgba(255, 255, 255, 0)',
        groupBorderColor: '#e8bb27',
        ghostBg: 'rgba(255, 255, 255, 0)',
        defaultGhostColor: '#141414',
        defaultGhostBorderColor: '#141414',
        defaultColor: 'rgba(255, 255, 255, 0.85)',
        defaultBorderColor: '#424242',
        defaultBg: '#141414',
        dangerColor: '#ffffff',
        borderColorDisabled: '#424242',
        defaultHoverBg: '#141414',
        defaultHoverColor: '#e8bb27',
        defaultHoverBorderColor: '#e8bb27',
        defaultActiveBg: '#141414',
        defaultActiveColor: '#ad8107',
        defaultActiveBorderColor: '#ad8107',
        fontWeight: 400,
        contentFontSizeSM: 14,
        contentLineHeightLG: 1.5,
        contentLineHeightSM: 1.5714285714285714,
        textTextActiveColor: 'rgba(255, 255, 255, 0.85)',
        textTextHoverColor: 'rgba(255, 255, 255, 0.85)',
        textTextColor: 'rgba(255, 255, 255, 0.85)',
        colorPrimaryBg: '#2c2311',
        colorBgSolid: 'rgba(255, 255, 255, 0.95)',
        colorBgSolidActive: 'rgba(255, 255, 255, 0.9)',
        colorBgSolidHover: '#ffffff',
        colorFillTertiary: 'rgba(255, 255, 255, 0.08)',
        solidTextColor: '#000000'
      },
      Badge: {
        statusSize: 6,
        indicatorHeight: 20,
        dotSize: 6,
        paddingXS: 8,
        marginXS: 8,
        lineWidth: 1,
        borderRadiusSM: 4,
        fontSizeSM: 12,
        fontSize: 14,
        colorWarning: '#d89614',
        colorTextPlaceholder: 'rgba(255, 255, 255, 0.25)',
        colorTextLightSolid: '#ffffff',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorSuccess: '#49aa19',
        colorPrimary: '#ffbc00',
        colorErrorHover: '#e86e6b',
        colorError: '#dc4446',
        colorBorderBg: '#141414',
        colorBgContainer: '#141414',
        indicatorHeightSM: 14,
        textFontSize: 12,
        textFontSizeSM: 12,
        fontHeight: 22,
        lineHeight: 1.5714285714285714,
        fontFamily: 'DM Sans'
      },
      Form: {
        screenXSMax: 575,
        screenSMMax: 767,
        screenMDMax: 991,
        screenLGMax: 1199,
        paddingXS: 8,
        paddingSM: 12,
        marginXXS: 4,
        marginXS: 8,
        marginLG: 24,
        margin: 16,
        lineWidth: 1,
        lineHeight: 1.5714285714285714,
        fontSizeLG: 16,
        fontSize: 14,
        controlOutlineWidth: 2,
        controlOutline: 'rgba(255, 188, 0, 0.1)',
        controlHeightSM: 24,
        controlHeightLG: 40,
        controlHeight: 32,
        colorWarning: '#d89614',
        colorTextHeading: 'rgba(255, 255, 255, 0.85)',
        colorTextDescription: 'rgba(255, 255, 255, 0.45)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorSuccess: '#49aa19',
        colorPrimary: '#ffbc00',
        colorError: '#dc4446',
        colorBorder: '#424242',
        labelRequiredMarkColor: '#dc4446',
        labelColor: 'rgba(255, 255, 255, 0.85)',
        itemMarginBottom: 24,
        labelColonMarginInlineEnd: 8,
        labelColonMarginInlineStart: 2,
        labelHeight: 32,
        labelFontSize: 14,
        fontFamily: 'DM Sans'
      },
      Avatar: {
        marginXXS: 4,
        marginXS: 8,
        lineWidth: 1,
        lineHeight: 1.5714285714285714,
        fontSizeXL: 20,
        fontSizeLG: 16,
        fontSizeHeading3: 24,
        fontSize: 14,
        borderRadiusSM: 4,
        borderRadiusLG: 8,
        borderRadius: 4,
        colorTextPlaceholder: 'rgba(255, 255, 255, 0.25)',
        colorTextLightSolid: '#ffffff',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorBorderBg: '#141414',
        containerSizeSM: 24,
        containerSizeLG: 40,
        containerSize: 32,
        textFontSize: 18,
        textFontSizeLG: 24,
        textFontSizeSM: 14,
        fontFamily: 'DM Sans'
      },
      Tour: {
        sizePopupArrow: 16,
        paddingXS: 8,
        padding: 16,
        marginXS: 8,
        lineHeight: 1.5714285714285714,
        fontWeightStrong: 600,
        fontSize: 14,

        colorWhite: '#ffffff',
        colorTextLightSolid: '#ffffff',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorPrimary: '#ffbc00',
        colorIconHover: 'rgba(255, 255, 255, 0.85)',
        colorIcon: 'rgba(255, 255, 255, 0.45)',
        colorFill: 'rgba(255, 255, 255, 0.18)',
        colorBgTextHover: 'rgba(255, 255, 255, 0.12)',
        colorBgElevated: '#1f1f1f',
        closeBtnSize: 22,
        primaryNextBtnHoverBg: '#f0f0f0',
        primaryPrevBtnBg: 'rgba(255, 255, 255, 0.15)',
        fontFamily: 'DM Sans',
        lineWidthFocus: 4
      },
      QRCode: {
        paddingSM: 12,
        marginXS: 8,
        lineWidth: 1,
        lineHeight: 1.5714285714285714,
        fontSize: 14,
        controlHeight: 32,
        borderRadiusLG: 8,
        colorWhite: '#ffffff',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorSplit: 'rgba(255, 255, 255, 0.06)',
        fontFamily: 'DM Sans'
      },
      Upload: {
        paddingXS: 8,
        paddingSM: 12,
        padding: 16,
        marginXXS: 4,
        marginXS: 8,
        marginXL: 32,
        margin: 16,
        lineWidth: 1,
        lineHeight: 1.5714285714285714,
        fontSizeLG: 16,
        fontSizeHeading3: 24,
        fontSizeHeading2: 30,
        fontSize: 14,
        controlItemBgHover: 'rgba(255, 255, 255, 0.08)',
        controlHeightLG: 40,
        borderRadiusLG: 8,
        colorTextLightSolid: '#ffffff',
        colorTextHeading: 'rgba(255, 255, 255, 0.85)',
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorTextDescription: 'rgba(255, 255, 255, 0.45)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorPrimaryHover: '#e8bb27',
        colorPrimary: '#ffbc00',
        colorFillAlter: 'rgba(255, 255, 255, 0.04)',
        colorErrorBg: '#2c1618',
        colorError: '#dc4446',
        colorBorder: '#424242',
        colorBgMask: 'rgba(0, 0, 0, 0.45)',
        fontHeight: 22,
        fontHeightSM: 20,
        lineWidthFocus: 4,
        fontFamily: 'DM Sans'
      },
      Typography: {
        paddingSM: 12,
        marginXXS: 4,
        marginXS: 8,
        lineWidth: 1,
        lineHeightHeading5: 1.5,
        lineHeightHeading4: 1.4,
        lineHeightHeading3: 1.3333333333333333,
        lineHeightHeading2: 1.2666666666666666,
        lineHeightHeading1: 1.2105263157894737,
        lineHeight: 1.5714285714285714,
        fontWeightStrong: 600,
        fontSizeHeading5: 16,
        fontSizeHeading4: 20,
        fontSizeHeading3: 24,
        fontSizeHeading2: 30,
        fontSizeHeading1: 38,
        fontSize: 14,
        colorWarning: '#d89614',
        colorTextHeading: 'rgba(255, 255, 255, 0.85)',
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorTextDescription: 'rgba(255, 255, 255, 0.45)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorSuccess: '#49aa19',
        colorLinkHover: '#e8bb27',
        colorLinkActive: '#ad8107',
        colorLink: '#ffbc00',
        colorErrorHover: '#e86e6b',
        colorErrorActive: '#ad393a',
        colorError: '#dc4446',
        fontFamilyCode: 'Courier Prime'
      },
      TreeSelect: {
        paddingXS: 8,
        marginXXS: 4,
        marginXS: 8,
        lineWidthFocus: 4,
        lineWidthBold: 2,
        lineWidth: 1,
        lineHeight: 1.5714285714285714,
        fontSizeLG: 16,
        fontSize: 14,
        controlItemBgHover: 'rgba(255, 255, 255, 0.08)',
        controlItemBgActive: '#2c2311',
        controlInteractiveSize: 16,
        controlHeightSM: 24,
        borderRadiusSM: 4,
        borderRadius: 4,
        colorWhite: '#ffffff',
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorPrimaryHover: '#e8bb27',
        colorPrimaryBorder: '#5b460e',
        colorPrimary: '#ffbc00',
        colorBorder: '#424242',
        colorBgElevated: '#1f1f1f',
        colorBgContainerDisabled: 'rgba(255, 255, 255, 0.08)',
        colorBgContainer: '#141414',
        titleHeight: 24,
        nodeSelectedBg: '#2c2311',
        nodeHoverBg: 'rgba(255, 255, 255, 0.08)',
        fontFamily: 'DM Sans',
        borderRadiusLG: 8
      },
      Tree: {
        paddingSM: 12,
        borderRadiusLG: 8,
        paddingXS: 8,
        marginXXS: 4,
        marginXS: 8,
        lineWidthFocus: 4,
        lineWidthBold: 2,
        lineWidth: 1,
        lineHeight: 1.5714285714285714,
        fontSizeLG: 16,
        fontSize: 14,
        controlItemBgHover: 'rgba(255, 255, 255, 0.08)',
        controlItemBgActive: '#2c2311',
        controlInteractiveSize: 16,
        controlHeightSM: 24,
        borderRadiusSM: 4,
        borderRadius: 4,
        colorWhite: '#ffffff',
        colorTextLightSolid: '#ffffff',
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorPrimaryHover: '#e8bb27',
        colorPrimaryBorder: '#5b460e',
        colorPrimary: '#ffbc00',
        colorBorder: '#424242',
        colorBgContainerDisabled: 'rgba(255, 255, 255, 0.08)',
        colorBgContainer: '#141414',
        titleHeight: 24,
        nodeSelectedBg: '#2c2311',
        nodeHoverBg: 'rgba(255, 255, 255, 0.08)',
        directoryNodeSelectedColor: '#ffffff',
        directoryNodeSelectedBg: '#ffbc00',
        fontFamily: 'DM Sans',
        nodeHoverColor: 'rgba(255, 255, 255, 0.85)',
        nodeSelectedColor: 'rgba(255, 255, 255, 0.85)',
        indentSize: 24
      },
      Tag: {
        paddingXXS: 4,
        marginXS: 8,
        lineWidth: 1,
        lineHeightSM: 1.6666666666666667,
        lineHeight: 1.5714285714285714,
        fontSizeSM: 12,
        fontSizeIcon: 12,
        fontSize: 14,
        borderRadiusSM: 4,
        colorTextLightSolid: '#ffffff',
        colorTextHeading: 'rgba(255, 255, 255, 0.85)',
        colorTextDescription: 'rgba(255, 255, 255, 0.45)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorPrimaryHover: '#e8bb27',
        colorPrimaryActive: '#ad8107',
        colorPrimary: '#ffbc00',
        colorFillTertiary: 'rgba(255, 255, 255, 0.08)',
        colorFillSecondary: 'rgba(255, 255, 255, 0.12)',
        colorFillQuaternary: 'rgba(255, 255, 255, 0.04)',
        colorBorder: '#424242',
        colorWarningBorder: '#594214',
        colorWarningBg: '#2b2111',
        colorSuccessBorder: '#274916',
        colorSuccessBg: '#162312',
        colorInfoBorder: '#5b460e',
        colorInfoBg: '#2c2311',
        colorErrorBorder: '#5b2526',
        colorErrorBg: '#2c1618',
        defaultColor: 'rgba(255, 255, 255, 0.85)',
        defaultBg: 'rgba(255, 255, 255, 0.04)',
        fontFamily: 'DM Sans'
      },
      Statistic: {
        padding: 16,
        marginXXS: 4,
        lineHeight: 1.5714285714285714,
        fontSizeHeading3: 24,
        fontSize: 14,
        colorTextHeading: 'rgba(255, 255, 255, 0.85)',
        colorTextDescription: 'rgba(255, 255, 255, 0.45)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        contentFontSize: 24,
        titleFontSize: 14,
        fontFamily: 'DM Sans'
      },
      Skeleton: {
        padding: 16,
        marginXXS: 4,
        marginSM: 12,
        marginLG: 24,
        controlHeightXS: 16,
        controlHeightSM: 24,
        controlHeightLG: 40,
        controlHeight: 32,
        borderRadiusSM: 4,
        colorFillContent: 'rgba(255, 255, 255, 0.12)',
        colorFill: 'rgba(255, 255, 255, 0.18)'
      },
      Select: {
        paddingXXS: 4,
        paddingXS: 8,
        paddingSM: 12,
        lineWidth: 1,
        lineHeight: 1.5714285714285714,
        fontWeightStrong: 600,
        fontSizeSM: 12,
        fontSizeLG: 16,
        fontSizeIcon: 12,
        fontSize: 14,
        controlPaddingHorizontalSM: 8,
        controlPaddingHorizontal: 12,
        controlOutlineWidth: 2,
        controlOutline: 'rgba(255, 188, 0, 0.1)',
        controlItemBgHover: 'rgba(255, 255, 255, 0.08)',
        controlItemBgActive: '#2c2311',
        controlHeightXS: 16,
        controlHeightSM: 24,
        controlHeightLG: 40,
        controlHeight: 32,
        borderRadiusXS: 2,
        borderRadiusSM: 4,
        borderRadiusLG: 8,
        borderRadius: 4,
        colorWarningOutline: 'rgba(173, 107, 0, 0.15)',
        colorWarningHover: '#7c5914',
        colorTextTertiary: 'rgba(255, 255, 255, 0.45)',
        colorTextQuaternary: 'rgba(255, 255, 255, 0.25)',
        colorTextPlaceholder: 'rgba(255, 255, 255, 0.25)',
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorTextDescription: 'rgba(255, 255, 255, 0.45)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorPrimaryHover: '#e8bb27',
        colorPrimary: '#ffbc00',
        colorIconHover: 'rgba(255, 255, 255, 0.85)',
        colorIcon: 'rgba(255, 255, 255, 0.45)',
        colorFillSecondary: 'rgba(255, 255, 255, 0.12)',
        colorErrorOutline: 'rgba(238, 38, 56, 0.11)',
        colorErrorHover: '#e86e6b',
        colorBorder: '#424242',
        colorBgElevated: '#1f1f1f',
        colorBgContainerDisabled: 'rgba(255, 255, 255, 0.08)',
        colorBgContainer: '#141414',
        singleItemHeightLG: 40,
        selectorBg: '#141414',
        optionSelectedColor: 'rgba(255, 255, 255, 0.85)',
        optionSelectedBg: '#2c2311',
        optionLineHeight: null,
        optionHeight: 32,
        optionActiveBg: 'rgba(255, 255, 255, 0.08)',
        multipleSelectorBgDisabled: 'rgba(255, 255, 255, 0.08)',
        multipleItemHeightLG: 32,
        multipleItemHeight: 24,
        multipleItemColorDisabled: 'rgba(255, 255, 255, 0.25)',
        multipleItemBorderColorDisabled: 'rgba(255, 255, 255, 0)',
        multipleItemBorderColor: 'rgba(255, 255, 255, 0)',
        multipleItemBg: 'rgba(255, 255, 255, 0.12)',
        clearBg: '#141414',
        optionFontSize: 'DM Sans',
        optionSelectedFontWeight: 600,
        fontFamily: 'DM Sans',
        showArrowPaddingInlineEnd: 18,
        activeBorderColor: '#ffbc00',
        hoverBorderColor: '#e8bb27',
        colorErrorBg: '#2c1618',
        colorErrorBgHover: '#451d1f',
        colorWarningBg: '#2b2111',
        colorWarningBgHover: '#443111',
        colorFillTertiary: 'rgba(255, 255, 255, 0.08)',
        colorSplit: 'rgba(255, 255, 255, 0.06)',
        colorWarning: '#d89614',
        colorError: '#dc4446'
      },
      Result: {
        paddingXS: 8,
        paddingXL: 32,
        paddingLG: 24,
        padding: 16,
        marginXS: 8,
        lineHeightHeading3: 1.3333333333333333,
        lineHeight: 1.5714285714285714,
        fontSizeHeading3: 24,
        fontSize: 14,
        colorWarning: '#d89614',
        colorTextHeading: 'rgba(255, 255, 255, 0.85)',
        colorTextDescription: 'rgba(255, 255, 255, 0.45)',
        colorSuccess: '#49aa19',
        colorInfo: '#ffbc00',
        colorFillAlter: 'rgba(255, 255, 255, 0.04)',
        colorError: '#dc4446',
        iconFontSize: 72,
        subtitleFontSize: 14,
        titleFontSize: 24
      },
      Progress: {
        paddingXS: 8,
        marginXXS: 4,
        marginXS: 8,
        lineHeight: 1.5714285714285714,
        fontSizeSM: 12,
        fontSize: 14,
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorSuccess: '#49aa19',
        colorFillSecondary: 'rgba(255, 255, 255, 0.12)',
        colorError: '#dc4446',
        colorBgContainer: '#141414',
        remainingColor: 'rgba(255, 255, 255, 0.12)',
        defaultColor: '#ffbc00',
        circleTextColor: 'rgba(255, 255, 255, 0.85)',
        fontFamily: 'DM Sans'
      },
      Popconfirm: {
        marginXXS: 4,
        marginXS: 8,
        fontWeightStrong: 600,
        fontSize: 14,
        colorWarning: '#d89614',
        colorTextHeading: 'rgba(255, 255, 255, 0.85)',
        colorText: 'rgba(255, 255, 255, 0.85)'
      },
      Pagination: {
        screenSM: 576,
        screenLG: 992,
        paddingXXS: 4,
        paddingSM: 12,
        marginXXS: 4,
        marginXS: 8,
        marginSM: 12,
        margin: 16,
        lineWidthFocus: 4,
        lineWidth: 1,
        lineHeightLG: 1.5,
        lineHeight: 1.5714285714285714,
        fontWeightStrong: 600,
        fontSizeSM: 12,
        fontSizeLG: 16,
        fontSize: 14,
        controlPaddingHorizontalSM: 8,
        controlPaddingHorizontal: 12,
        controlOutlineWidth: 2,
        controlOutline: 'rgba(255, 188, 0, 0.1)',
        controlItemBgActiveDisabled: 'rgba(255, 255, 255, 0.18)',
        controlHeightSM: 24,
        controlHeightLG: 40,
        controlHeight: 32,
        borderRadiusSM: 4,
        borderRadiusLG: 8,
        borderRadius: 4,
        colorWarningOutline: 'rgba(173, 107, 0, 0.15)',
        colorTextPlaceholder: 'rgba(255, 255, 255, 0.25)',
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorPrimaryHover: '#e8bb27',
        colorPrimaryBorder: '#5b460e',
        colorPrimary: '#ffbc00',
        colorFillAlter: 'rgba(255, 255, 255, 0.04)',
        colorErrorOutline: 'rgba(238, 38, 56, 0.11)',
        colorBorder: '#424242',
        colorBgTextHover: 'rgba(255, 255, 255, 0.12)',
        colorBgTextActive: 'rgba(255, 255, 255, 0.18)',
        colorBgContainerDisabled: 'rgba(255, 255, 255, 0.08)',
        colorBgContainer: '#141414',
        itemSizeSM: 24,
        itemSize: 32,
        itemLinkBg: '#141414',
        itemInputBg: '#141414',
        itemBg: '#141414',
        itemActiveColorDisabled: 'rgba(255, 255, 255, 0.25)',
        itemActiveBgDisabled: 'rgba(255, 255, 255, 0.18)',
        itemActiveBg: '#141414',
        fontFamily: 'DM Sans'
      },
      Modal: {
        screenSMMax: 767,
        paddingXS: 8,
        paddingMD: 20,
        paddingLG: 24,
        paddingContentHorizontalLG: 24,
        padding: 16,
        marginXS: 8,
        marginSM: 12,
        marginLG: 24,
        margin: 16,
        lineWidthFocus: 4,
        lineWidth: 1,
        lineHeightHeading5: 1.5,
        lineHeight: 1.5714285714285714,
        fontWeightStrong: 600,
        fontSizeLG: 16,
        fontSizeHeading5: 16,
        fontSize: 14,
        borderRadiusSM: 4,
        borderRadiusLG: 8,
        colorWarning: '#d89614',
        colorTextHeading: 'rgba(255, 255, 255, 0.85)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorSuccess: '#49aa19',
        colorPrimaryBorder: '#5b460e',
        colorIconHover: 'rgba(255, 255, 255, 0.85)',
        colorIcon: 'rgba(255, 255, 255, 0.45)',
        colorBgMask: 'rgba(0, 0, 0, 0.45)',
        titleColor: 'rgba(255, 255, 255, 0.85)',
        headerBg: '#1f1f1f',
        footerBg: 'rgba(255, 255, 255, 0)',
        contentBg: '#1f1f1f',
        titleFontSize: 16,
        titleLineHeight: 1.375,
        fontHeight: 22,
        fontFamily: 'DM Sans'
      },
      Message: {
        paddingXS: 8,
        paddingSM: 12,
        marginXS: 8,
        lineHeight: 1.5714285714285714,
        fontSizeLG: 16,
        fontSize: 14,
        controlHeightLG: 40,
        borderRadiusLG: 8,
        colorWarning: '#d89614',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorSuccess: '#49aa19',
        colorInfo: '#ffbc00',
        colorError: '#dc4446',
        contentBg: '#1f1f1f',
        fontFamily: 'DM Sans'
      },
      List: {
        screenSM: 576,
        screenMD: 768,
        paddingXS: 8,
        paddingSM: 12,
        paddingLG: 24,
        paddingContentVerticalSM: 8,
        paddingContentVerticalLG: 16,
        paddingContentVertical: 12,
        paddingContentHorizontalLG: 24,
        paddingContentHorizontal: 16,
        padding: 16,
        marginXXS: 4,
        marginXXL: 48,
        marginSM: 12,
        marginLG: 24,
        margin: 16,
        lineWidth: 1,
        lineHeightLG: 1.5,
        lineHeight: 1.5714285714285714,
        fontSizeSM: 12,
        fontSizeLG: 16,
        fontSize: 14,
        controlHeightLG: 40,
        controlHeight: 32,
        borderRadiusLG: 8,
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorTextDescription: 'rgba(255, 255, 255, 0.45)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorSplit: 'rgba(255, 255, 255, 0.06)',
        colorPrimary: '#ffbc00',
        colorBorder: '#424242',
        headerBg: 'rgba(255, 255, 255, 0)',
        footerBg: 'rgba(255, 255, 255, 0)',
        avatarMarginRight: 16,
        descriptionFontSize: 14,
        fontFamily: 'DM Sans'
      },
      FloatButton: {
        paddingXXS: 4,
        marginXXL: 48,
        marginLG: 24,
        margin: 16,
        lineWidth: 1,
        lineHeight: 1.5714285714285714,
        fontSizeSM: 12,
        fontSizeLG: 16,
        fontSizeIcon: 12,
        fontSize: 14,
        controlItemBgHover: 'rgba(255, 255, 255, 0.08)',
        controlHeightLG: 40,
        borderRadiusSM: 4,
        borderRadiusLG: 8,
        colorTextLightSolid: '#ffffff',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorSplit: 'rgba(255, 255, 255, 0.06)',
        colorPrimaryHover: '#e8bb27',
        colorPrimary: '#ffbc00',
        colorFillContent: 'rgba(255, 255, 255, 0.12)',
        colorBgElevated: '#1f1f1f',
        fontFamily: 'DM Sans'
      },
      Empty: {
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorTextDescription: 'rgba(255, 255, 255, 0.45)',
        fontSize: 14,
        lineHeight: 1.5714285714285714
      },
      Dropdown: {
        sizePopupArrow: 16,
        paddingXXS: 4,
        paddingXS: 8,
        marginXXS: 4,
        marginXS: 8,
        lineWidthFocus: 4,
        lineHeight: 1.5714285714285714,
        fontSizeSM: 12,
        fontSizeIcon: 12,
        fontSize: 14,
        controlPaddingHorizontal: 12,
        controlItemBgHover: 'rgba(255, 255, 255, 0.08)',
        controlItemBgActiveHover: '#45350f',
        controlItemBgActive: '#2c2311',
        controlHeight: 32,
        borderRadiusXS: 2,
        borderRadiusSM: 4,
        borderRadiusLG: 8,
        colorTextLightSolid: '#ffffff',
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorTextDescription: 'rgba(255, 255, 255, 0.45)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorSplit: 'rgba(255, 255, 255, 0.06)',
        colorPrimaryBorder: '#5b460e',
        colorPrimary: '#ffbc00',
        colorError: '#dc4446',
        colorBgElevated: '#1f1f1f',
        paddingBlock: 5,
        fontFamily: 'DM Sans'
      },
      Drawer: {
        paddingXS: 8,
        paddingLG: 24,
        padding: 16,
        marginSM: 12,
        lineWidth: 1,
        lineHeightLG: 1.5,
        fontWeightStrong: 600,
        fontSizeLG: 16,
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorSplit: 'rgba(255, 255, 255, 0.06)',
        colorIconHover: 'rgba(255, 255, 255, 0.85)',
        colorIcon: 'rgba(255, 255, 255, 0.45)',
        colorBgMask: 'rgba(0, 0, 0, 0.45)',
        colorBgElevated: '#1f1f1f',
        lineWidthFocus: 4
      },
      Divider: {
        marginXS: 8,
        marginLG: 24,
        margin: 16,
        lineWidth: 1,
        fontSizeLG: 16,
        fontSize: 14,
        colorTextHeading: 'rgba(255, 255, 255, 0.85)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorSplit: 'rgba(255, 255, 255, 0.06)',
        lineHeight: 1.5714285714285714,
        fontFamily: 'DM Sans'
      },
      Descriptions: {
        paddingXS: 8,
        paddingSM: 12,
        paddingLG: 24,
        padding: 16,
        marginXXS: 4,
        marginXS: 8,
        lineWidth: 1,
        lineHeightSM: 1.6666666666666667,
        lineHeightLG: 1.5,
        lineHeight: 1.5714285714285714,
        fontWeightStrong: 600,
        fontSizeSM: 12,
        fontSizeLG: 16,
        fontSize: 14,
        borderRadiusLG: 8,
        colorTextTertiary: 'rgba(255, 255, 255, 0.45)',
        colorTextSecondary: 'rgba(255, 255, 255, 0.65)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorSplit: 'rgba(255, 255, 255, 0.06)',
        colorFillAlter: 'rgba(255, 255, 255, 0.04)',
        titleColor: 'rgba(255, 255, 255, 0.85)',
        labelBg: 'rgba(255, 255, 255, 0.04)',
        contentColor: 'rgba(255, 255, 255, 0.85)',
        fontFamily: 'DM Sans',
        labelColor: 'rgba(255, 255, 255, 0.45)'
      },
      DatePicker: {
        'sizePopupArrow': 16,
        'paddingXXS': 4,
        'paddingXS': 8,
        'paddingSM': 12,
        'padding': 16,
        'marginXXS': 4,
        'marginXS': 8,
        'lineWidthBold': 2,
        'lineWidth': 1,
        'lineHeightLG': 1.5,
        'lineHeight': 1.5714285714285714,
        'fontWeightStrong': 600,
        'fontSizeLG': 16,
        'fontSize': 14,
        'controlPaddingHorizontalSM': 8,
        'controlPaddingHorizontal': 12,
        'controlOutlineWidth': 2,
        'controlOutline': 'rgba(255, 188, 0, 0.1)',
        'controlItemBgHover': 'rgba(255, 255, 255, 0.08)',
        'controlItemBgActive': '#2c2311',
        'controlHeightSM': 24,
        'controlHeightLG': 40,
        'controlHeight': 32,
        'borderRadiusXS': 2,
        'borderRadiusSM': 4,
        'borderRadiusLG': 8,
        'borderRadius': 4,
        'colorWarningOutline': 'rgba(173, 107, 0, 0.15)',
        'colorWarningHover': '#7c5914',
        'colorWarning': '#d89614',
        'colorTextQuaternary': 'rgba(255, 255, 255, 0.25)',
        'colorTextPlaceholder': 'rgba(255, 255, 255, 0.25)',
        'colorTextLightSolid': '#ffffff',
        'colorTextHeading': 'rgba(255, 255, 255, 0.85)',
        'colorTextDisabled': 'rgba(255, 255, 255, 0.25)',
        'colorTextDescription': 'rgba(255, 255, 255, 0.45)',
        'colorText': 'rgba(255, 255, 255, 0.85)',
        'colorSplit': 'rgba(255, 255, 255, 0.06)',
        'colorPrimaryHover': '#e8bb27',
        'colorPrimaryBorder': '#5b460e',
        'colorPrimary': '#ffbc00',
        'colorLinkHover': '#e8bb27',
        'colorLinkActive': '#ad8107',
        'colorLink': '#ffbc00',
        'colorIconHover': 'rgba(255, 255, 255, 0.85)',
        'colorIcon': 'rgba(255, 255, 255, 0.45)',
        'colorFillAlter': 'rgba(255, 255, 255, 0.04)',
        'colorErrorOutline': 'rgba(238, 38, 56, 0.11)',
        'colorErrorHover': '#e86e6b',
        'colorError': '#dc4446',
        'colorBorder': '#424242',
        'colorBgElevated': '#1f1f1f',
        'colorBgContainerDisabled': 'rgba(255, 255, 255, 0.08)',
        'colorBgContainer': '#141414',
        'hoverBorderColor': '#e8bb27',
        'cellHoverBg': 'rgba(255, 255, 255, 0.08)',
        'cellHeight': 24,
        'activeBorderColor': '#ffbc00',
        'paddingInline': 11,
        'paddingInlineSM': 7,
        'colorFillTertiary': 'rgba(255, 255, 255, 0.08)',
        'colorErrorBg': '#2c1618',
        'colorWarningBg': '#2b2111',
        'colorWarningText': '#d89614',
        'colorErrorText': '#dc4446',
        'colorWarningBgHover': '#443111',
        'colorErrorBgHover': '#451d1f',
        'activeBg': '#141414',
        'hoverBg': '#141414',
        'cellBgDisabled': 'rgba(255, 255, 255, 0.08)',
        'cellActiveWithRangeBg': '#2c2311',
        'cellHoverWithRangeBg': '#c8dfff',
        'cellRangeBorderColor': '#7cb3ff',
        'multipleItemBg': 'rgba(255, 255, 255, 0.12)',
        'multipleItemBorderColor': 'rgba(255, 255, 255, 0)',
        'multipleItemBorderColorDisabled': 'rgba(255, 255, 255, 0)',
        'multipleItemColorDisabled': 'rgba(255, 255, 255, 0.25)',
        'multipleSelectorBgDisabled': 'rgba(255, 255, 255, 0.08)',
        'cellWidth': 36,
        'multipleItemHeight': 24,
        'multipleItemHeightLG': 32,
        'multipleItemHeightSM': 16,
        'paddingBlock': 4,
        'paddingBlockLG': 7,
        'paddingBlockSM': 0,
        'paddingInline 2': 11,
        'presetsMaxWidth': 200,
        'presetsWidth': 120,
        'textHeight': 40,
        'timeCellHeight': 28,
        'timeColumnHeight': 224,
        'timeColumnWidth': 56,
        'withoutTimeCellHeight': 66,
        'inputFontSize': 14,
        'inputFontSizeLG': 16,
        'inputFontSizeSM': 12,
        'fontHeight': 22,
        'fontHeightLG': 24,
        'fontFamily': 'DM Sans',
        'colorFillSecondary': 'rgba(255, 255, 255, 0.12)'
      },
      Collapse: {
        paddingXXS: 4,
        paddingXS: 8,
        paddingSM: 12,
        paddingLG: 24,
        padding: 16,
        marginSM: 12,
        lineWidth: 1,
        lineHeight: 1.5714285714285714,
        fontSizeLG: 16,
        fontSizeIcon: 12,
        fontSize: 14,
        borderRadiusLG: 8,
        colorTextHeading: 'rgba(255, 255, 255, 0.85)',
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorFillAlter: 'rgba(255, 255, 255, 0.04)',
        colorBorder: '#424242',
        colorBgContainer: '#141414',
        headerBg: 'rgba(255, 255, 255, 0.04)',
        contentBg: '#141414',
        fontHeight: 22,
        fontHeightLG: 24,
        lineHeightLG: 1.5,
        fontFamily: 'DM Sans'
      },
      Checkbox: {
        paddingXS: 8,
        marginXS: 8,
        lineWidthFocus: 4,
        lineWidthBold: 2,
        lineWidth: 1,
        lineHeight: 1.5714285714285714,
        fontSizeLG: 16,
        fontSize: 14,
        controlInteractiveSize: 16,
        borderRadiusSM: 4,
        colorWhite: '#ffffff',
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorPrimaryHover: '#e8bb27',
        colorPrimaryBorder: '#5b460e',
        colorPrimary: '#ffbc00',
        colorBorder: '#424242',
        colorBgContainerDisabled: 'rgba(255, 255, 255, 0.08)',
        colorBgContainer: '#141414',
        fontFamily: 'DM Sans'
      },
      Breadcrumb: {
        paddingXXS: 4,
        marginXXS: 4,
        marginXS: 8,
        lineWidthFocus: 4,
        lineHeight: 1.5714285714285714,
        fontSizeIcon: 12,
        fontSize: 14,
        borderRadiusSM: 4,
        colorPrimaryBorder: '#5b460e',
        colorBgTextHover: 'rgba(255, 255, 255, 0.12)',
        separatorColor: 'rgba(255, 255, 255, 0.45)',
        linkHoverColor: 'rgba(255, 255, 255, 0.85)',
        linkColor: 'rgba(255, 255, 255, 0.45)',
        lastItemColor: 'rgba(255, 255, 255, 0.85)',
        itemColor: 'rgba(255, 255, 255, 0.45)',
        separatorMargin: 8,
        iconFontSize: 14,
        fontHeight: 22,
        fontFamily: 'DM Sans'
      },
      Anchor: {
        paddingXXS: 4,
        lineWidthBold: 2,
        lineHeight: 1.5714285714285714,
        fontSizeLG: 16,
        fontSize: 14,
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorSplit: 'rgba(255, 255, 255, 0.06)',
        colorPrimary: '#ffbc00',
        linkPaddingInlineStart: 16,
        linkPaddingBlock: 4,
        fontFamily: 'DM Sans'
      },
      Alert: {
        paddingMD: 20,
        paddingContentVerticalSM: 8,
        paddingContentHorizontalLG: 24,
        marginXS: 8,
        marginSM: 12,
        lineWidth: 1,
        lineHeight: 1.5714285714285714,
        fontSizeLG: 16,
        fontSizeIcon: 12,
        fontSizeHeading3: 24,
        fontSize: 14,
        borderRadiusLG: 8,
        colorWarningBorder: '#594214',
        colorWarningBg: '#2b2111',
        colorWarning: '#d89614',
        colorTextHeading: 'rgba(255, 255, 255, 0.85)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorSuccessBorder: '#274916',
        colorSuccessBg: '#162312',
        colorSuccess: '#49aa19',
        colorInfoBorder: '#5b460e',
        colorInfoBg: '#2c2311',
        colorInfo: '#ffbc00',
        colorIconHover: 'rgba(255, 255, 255, 0.85)',
        colorIcon: 'rgba(255, 255, 255, 0.45)',
        colorErrorBorder: '#5b2526',
        colorErrorBg: '#2c1618',
        colorError: '#dc4446',
        withDescriptionIconSize: 24,
        fontFamily: 'DM Sans'
      },
      Space: {
        paddingXS: 8,
        paddingLG: 24,
        padding: 16
      },
      AutoComplete: {
        paddingXXS: 4,
        paddingXS: 8,
        paddingSM: 12,
        lineWidth: 1,
        lineHeight: 1.5714285714285714,
        controlPaddingHorizontalSM: 8,
        controlPaddingHorizontal: 12,
        controlOutlineWidth: 2,
        controlOutline: 'rgba(255, 188, 0, 0.1)',
        controlItemBgHover: 'rgba(255, 255, 255, 0.08)',
        controlItemBgActive: '#2c2311',
        controlHeightXS: 16,
        controlHeightSM: 24,
        controlHeightLG: 40,
        controlHeight: 32,
        borderRadiusXS: 2,
        borderRadiusSM: 4,
        borderRadiusLG: 8,
        borderRadius: 4,
        colorWarningOutline: 'rgba(173, 107, 0, 0.15)',
        colorWarningHover: '#7c5914',
        colorWarning: '#d89614',
        colorTextTertiary: 'rgba(255, 255, 255, 0.45)',
        colorTextQuaternary: 'rgba(255, 255, 255, 0.25)',
        colorTextPlaceholder: 'rgba(255, 255, 255, 0.25)',
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorTextDescription: 'rgba(255, 255, 255, 0.45)',
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorPrimaryHover: '#e8bb27',
        colorPrimary: '#ffbc00',
        colorIconHover: 'rgba(255, 255, 255, 0.85)',
        colorIcon: 'rgba(255, 255, 255, 0.45)',
        colorFillSecondary: 'rgba(255, 255, 255, 0.12)',
        colorErrorOutline: 'rgba(238, 38, 56, 0.11)',
        colorErrorHover: '#e86e6b',
        colorError: '#dc4446',
        colorBorder: '#424242',
        colorBgElevated: '#1f1f1f',
        colorBgContainerDisabled: 'rgba(255, 255, 255, 0.08)',
        colorBgContainer: '#141414',
        optionActiveBg: 'rgba(0, 0, 0, 0.04)',
        optionHeight: 32,
        optionFontSize: 14,
        fontFamily: 'DM Sans',
        fontSize: 14,
        fontSizeIcon: 12,
        fontSizeLG: 16,
        fontSizeSM: 12
      },
      Layout: {
        bodyBg: '#000000',
        footerBg: '#000000',
        headerBg: '#001529',
        headerColor: 'rgba(255, 255, 255, 0.85)',
        lightSiderBg: '#141414',
        lightTriggerBg: '#141414',
        lightTriggerColor: 'rgba(255, 255, 255, 0.85)',
        siderBg: '#001529',
        triggerBg: '#002140',
        triggerColor: '#ffffff',
        colorText: 'rgba(255, 255, 255, 0.85)',
        headerHeight: 64,
        triggerHeight: 48,
        zeroTriggerHeight: 40,
        zeroTriggerWidth: 40,
        borderRadius: 4,
        fontSize: 14,
        fontSizeXL: 20
      },
      Mentions: {
        fontFamily: 'DM Sans',
        fontSize: 14,
        lineHeight: 1.5714285714285714
      },
      Splitter: {
        railSize: 4,
        handleSizeHover: 12,
        dotSize: 8,
        controlSize: 10,
        handleSize: 10,
        trackHoverBg: '#7e5f0b',
        trackBgDisabled: 'rgba(255, 255, 255, 0.08)',
        trackBg: '#5b460e',
        railHoverBg: 'rgba(255, 255, 255, 0.12)',
        railBg: 'rgba(255, 255, 255, 0.08)',
        handleColor: '#5b460e',
        handleColorDisabled: '#bfbfbf',
        handleActiveColor: '#ffbc00',
        dotBorderColor: '#303030',
        dotActiveBorderColor: '#5b460e',
        lineWidth: 1,
        controlHeightLG: 40,
        controlHeight: 32,
        colorTextDisabled: 'rgba(255, 255, 255, 0.25)',
        colorTextDescription: 'rgba(255, 255, 255, 0.45)',
        colorPrimaryBorderHover: '#7e5f0b',
        colorPrimaryBorder: '#5b460e',
        colorPrimary: '#ffbc00',
        colorFillTertiary: 'rgba(255, 255, 255, 0.08)',
        colorFillSecondary: 'rgba(255, 255, 255, 0.12)',
        colorFillContentHover: 'rgba(255, 255, 255, 0.18)',
        colorBorderSecondary: '#303030',
        colorBgElevated: '#1f1f1f',
        colorBgContainerDisabled: 'rgba(255, 255, 255, 0.08)',
        colorBgContainer: '#141414',
        resizeSpinnerSize: 20,
        lineHeight: 1.5714285714285714,
        fontSize: 14,
        fontFamily: 'DM Sans',
        controlHeightSM: 24,
        borderRadiusXS: 2,
        colorText: 'rgba(255, 255, 255, 0.85)',
        colorFill: 'rgba(255, 255, 255, 0.18)',
        controlItemBgActive: '#2c2311',
        controlItemBgActiveHover: '#45350f',
        controlItemBgHover: 'rgba(255, 255, 255, 0.08)',
        fontSizeSM: 12,
        splitBarSize: 2,
        splitTriggerSize: 6
      }
    }
  }
};
